import React, { useRef, useState, useEffect } from "react";
import { SketchPicker } from "react-color";
import { Affix, App, Button, Select, Typography, theme } from "antd";
import { Checkbox } from "antd";
import moment from "moment";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import useOnClickOutside from "../../hooks/useOutsideClick";

import Logo_Original from "../image/Logo_Original.png";
import Google from "../image/Google.png";
import { Divider } from "@mui/material";
import { Discovery } from "aws-sdk";
import config, { mobileNumberLimit, cardNumberLimit } from "../../config";
import { useCurrency } from "../../provider/courtryProvider";
import Title from "antd/es/typography/Title";
import { useBilling } from "../Kitchen/billingProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { useAccess } from "../../provider/AccessProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";

const dummy = [
  {
    SNo: "1",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "blue",
  },
  {
    SNo: "2",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "red",
  },
  {
    SNo: "3",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "0.9mm",
  },
  {
    SNo: "4",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "green",
  },
  {
    SNo: "5",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "0.7mm",
  },
  {
    SNo: "6",
    items: "Cello Pen Gel ",
    IMEI: "12345",
    HSN: "390110",
    MRP: "10000",
    Qty: "100pcs",
    Dics: "40%",
    Tax: "78%",
    Rate: "10000",
    Amount: "10000",
    variant: "black",
  },
];

const Invoice = ({ onHide = () => {}, mode = "bill" }) => {
  const [advanceSettings, setAdvanceSettings] = useState({
    b2bPricing: false,
    uniqueIdentity: false,
  });
  const access = useAccess(GENERATEBILLACCESS);
  const stickerref = useRef();
  const callback = useRef();
  const fcallback = useRef();
  const {
    token: { colorPrimary },
  } = theme.useToken();
  // const alertMsg = useRef();
  const currentDate = moment().format("DD-MM-YYYY");

  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  // console.log("invoiceSettings", invoiceSettings);
  const shopDetails = useSelector((state) => state.shopDetails);
  // console.log("shopDetails11", shopDetails);
  const [accounrDetails, setaccountDetails] = useState();
  const [container, setContainer] = useState(null);
  const [Fonttype, setFonttype] = useState();
  const [showButton, setshowButton] = useState(false);
  const [top, setTop] = useState(10);

  const [T55fontsize, setT55fontsize] = useState();
  const [T80fontsize, setT80fontsize] = useState();
  const {
    ItemDiscountTaxCheckbox,
    setState,
    updateProductPriceWhileSwitching,
  } = useBilling();
  const { AddDiscountOtherCharge } = useFooterData();
  const [A4fontsize, setA4fontsize] = useState();
  const [A4Fonttype, setA4Fonttype] = useState();
  const [color, setColor] = useState();
  const [changeButton, setchangeButtoon] = useState(false);
  const [settingData, setSettingsData] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [alertMessage, setalertMessage] = useState(true);
  const currencyFormatter = useCurrency();
  const pickerStyles = {
    default: {
      picker: {
        position: "absolute",
        marginLeft: "-160px",

        left: "100px",
      },
    },
  };

  const { Option } = Select;

  const onChange = (value) => {
    setFonttype(value);
  };
  const A4Onchange = (value) => {
    setA4Fonttype(value);
  };

  const ThermalFontSize55 = (value) => {
    setT55fontsize(value);
  };

  const ThermalFontSize88 = (value) => {
    setT80fontsize(value);
  };

  const A4FontSizes = (value) => {
    setA4fontsize(value);
  };

  const [Xerox, setXerox] = useState({
    printerType: "",
    thermalPapertype: "",
    A4design: "",
  });

  const updatePrint = (e) => {
    var fieldName = e.target.value;

    setXerox((prev) => ({ ...prev, [e.target.name]: fieldName }));
  };

  useEffect(() => {}, [Xerox]);

  const dispatch = useDispatch();

  /*main*/
  const initialSettings = {
    shoplogo: false,
    ShopURL: false,
    // billingaddress: false,
    // shipping: false,
    customerprivacy: false,
    itemmrp: false,
    variant: false,
    itemdiscount: false,
    hsncode: false,
    itemleveltax: false,
    imei1imei2: false,
    adddiscount: false,
    othercharges: false,
    deliveryaddress: false,
    notes: false,
    termscondition: false,
    paymenyterms: false,
    duedate: false,
    invoiceprefix: false,
    ghoshaklogo: false,
    QRCode: false,
    ShopAddress: false,
    uniqueIdentity: false,
    roundOff: false,
  };

  const [customization, setCustomization] = useState({ ...initialSettings });
  const updateSettings = (e) => {
    var fieldName = e.target.name;
    var fieldValue = customization[fieldName];
    setCustomization({ ...customization, [fieldName]: !fieldValue });
  };

  const [Invoicetext, setInvoicetext] = useState({
    tAndCField: "",
    paymentTermsField: "",
    invoiceSuffixtext: 2022001,
    invoicePrefixtext: "",
    otherChargesField: [],
    currentInvoiceNumber: 2022001,
  });

  useEffect(() => {
    setInvoicetext((prev) => ({
      ...prev,
      currentInvoiceNumber: customization.currentInvoiceNumber,
    }));
  }, []);
  useEffect(() => {
    if (shopDetails.accountDetails !== undefined) {
      setaccountDetails(shopDetails.accountDetails);
    }
  }, [shopDetails.accountDetails]);
  useEffect(() => {
    setAdvanceSettings(shopDetails.advanceSettings || {});
  }, [shopDetails.advanceSettings]);
  const updateText = (e) => {
    var fieldName = e.target.value;

    setInvoicetext((prev) => ({ ...prev, [e.target.name]: fieldName }));
  };

  const [hshow, setHshow] = useState(true);
  const [bshow, setBshow] = useState(true);
  const [Fshow, setFshow] = useState(true);

  const [newBillsettings, setNewBillsettings] = useState([]);

  function handleClick(e) {
    setchangeButtoon(true);
    e.preventDefault();

    var template = {
      type: "template",
      thermalPapertype: Xerox.thermalPapertype ? Xerox.thermalPapertype : "80",
      printerType: Xerox.printerType ? Xerox.printerType : "Thermal",
      A4design: Xerox.A4design ? Xerox.A4design : "Classic",
    };
    newBillsettings.push(template);
    var header = {
      type: "header",

      shoplogo: customization.shoplogo,
      ShopURL: customization.ShopURL,
      // billingaddress: customization.billingaddress,
      // shipping: customization.shipping,
      customerprivacy: customization.customerprivacy,
      ShopAddress: customization.ShopAddress,
    };
    newBillsettings.push(header);
    var body = {
      type: "body",
      variant: customization.variant,
      itemmrp: customization.itemmrp,
      itemdiscount: customization.itemdiscount,
      hsncode: customization.hsncode,
      itemleveltax: customization.itemleveltax,
      imei1imei2: customization.imei1imei2,
      adddiscount: customization.adddiscount,
      othercharges: customization.othercharges,
      roundOff: customization.roundOff,
    };
    newBillsettings.push(body);
    var footer = {
      type: "footer",
      deliveryaddress: customization.deliveryaddress,
      termscondition: customization.termscondition,
      paymenyterms: customization.paymenyterms,
      notes: customization.notes,
      // duedate: customization.duedate,
      invoiceprefix: customization.invoiceprefix,
      ghoshaklogo: customization.ghoshaklogo,
      QRCode: customization.QRCode,
    };
    newBillsettings.push(footer);
    var content = {
      type: "content",
      tAndCField: Invoicetext.tAndCField,
      paymentTermsField: Invoicetext.paymentTermsField,
      invoicePrefixtext: Invoicetext.invoicePrefixtext,
      invoiceSuffixtext: Invoicetext.invoiceSuffixtext,
      currentInvoiceNumber: Invoicetext.currentInvoiceNumber
        ? Invoicetext.currentInvoiceNumber
        : "000000",
    };

    newBillsettings.push(content);
    var design = {
      type: "design",
      Fonttype: Fonttype,
      color: color,
      T55fontsize: T55fontsize,
      T80fontsize: T80fontsize,
      A4Fonttype: A4Fonttype,
      uniqueIdentity: customization.uniqueIdentity,
      A4fontsize: A4fontsize,
    };
    newBillsettings.push(design);

    fetch(`${config.newApiGateway}/bill/customBillsettings`, {
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        newBillsettings: newBillsettings,
        shopId: shopDetails.shopId,
        type: "post",
      }),
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        setNewBillsettings([]);
        const updatedata = JSON.parse(data.body);

        let update = updatedata.Attributes.newBillsettings;
        let Newindata = {};
        for (let i = 0; i < update.length; i++) {
          Object.assign(Newindata, update[i]);
        }

        dispatch({
          type: "INVOICE-NEWBILLSETTINGS",
          payload: Newindata,
        });
        ItemDiscountTaxCheckbox(
          customization.itemdiscount,
          customization.itemleveltax
        );
        AddDiscountOtherCharge(
          customization.adddiscount,
          customization.othercharges,
          customization.notes
        );
        setchangeButtoon(false);

        return updatedata;
      })

      .catch((err) => console.log(err));
  }

  // useEffect(() => {
  //   fetch(`${config.ApiGateway1}/customBillsettings`, {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       shopId: shopDetails.shopId,
  //       type: "update",
  //     }),
  //     method: "POST",
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setNewBillsettings([]);
  //       const updatedata = JSON.parse(data.body);

  //       let update = updatedata.Item.newBillsettings;
  //       let Newindata = {};
  //       for (let i = 0; i < update.length; i++) {
  //         Object.assign(Newindata, update[i]);
  //       }

  //       console.log("Newindata",Newindata)

  //       dispatch({
  //         type: "INVOICE-NEWBILLSETTINGS",
  //         payload: Newindata,
  //       });

  //       setCustomization(Newindata);
  //       setInvoicetext(Newindata);
  //       setXerox(Newindata);
  //       setColor(Newindata.color);
  //       setFonttype(Newindata.Fonttype);
  //       setT55fontsize(Newindata.T55fontsize);

  //       setA4fontsize(Newindata.A4fontsize);
  //       setT80fontsize(Newindata.T80fontsize);
  //       setA4Fonttype(Newindata.A4Fonttype);

  //       return updatedata;
  //     })

  //     .catch((err) => console.log(err));
  // }, []);

  useEffect(() => {
    if (shopDetails.shopType !== "Restaurent") {
      if (shopDetails.shopId) {
        setshowButton(false);
        fetch(`${config.newApiGateway}/bill/customBillsettings`, {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ shopId: shopDetails.shopId, type: "update" }),
          method: "POST",
        })
          .then((res) => res.json())
          .then((data) => {
            // const Check boxdata= JSON.parse(data)
            console.log("Checkboxdata------", data);
            let Checkboxdata = data.newBillsettings;
            let UpdateCheckbox = {};
            for (let i = 0; i < Checkboxdata.length; i++) {
              Object.assign(UpdateCheckbox, Checkboxdata[i]);
            }

            console.log(
              "\nAfter converting  Billing_______----",
              UpdateCheckbox
            );
            dispatch({
              type: "INVOICE-NEWBILLSETTINGS",
              payload: UpdateCheckbox,
            });
            setSettingsData(data.newBillsettings);
            setCustomization(UpdateCheckbox);
            setInvoicetext(UpdateCheckbox);
            setXerox(UpdateCheckbox);
            setColor(UpdateCheckbox.color);
            setFonttype(UpdateCheckbox.Fonttype);
            setT55fontsize(UpdateCheckbox.T55fontsize);

            setA4fontsize(UpdateCheckbox.A4fontsize);
            setT80fontsize(UpdateCheckbox.T80fontsize);
            setA4Fonttype(UpdateCheckbox.A4Fonttype);
            setshowButton(true);
            setchangeButtoon(false);

            return Checkboxdata;
          });
      }
    }
  }, [shopDetails.shopId]);

  const [timer, setTimer] = useState(null);

  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        console.log(change);
      }, 3000)
    );
  }

  useOnClickOutside(stickerref, () => setHidden(false));
  // useOnClickOutside(alertMsg, () => {
  //   if(alertMessage===true){
  //     if (window.confirm('Do you want to save the changes?')) {
  //       // Save it!
  //       callback.current.click();
  //       onHide(false);
  //     } else {
  //       // Do nothing!
  //       onHide(false);
  //       console.log('Thing was not saved to the database.');
  //     }
  //   }
  // });

  // useOnClickOutside( fcallback, () => callback.current.click() );

  const saveSettings = async () => {
    const updateSettingData = settingData.map((i) => {
      if (i.type === "design") {
        return {
          ...i,
          uniqueIdentity: customization.uniqueIdentity,
        };
      }
      return i;
    });
    try {
      const response = await fetch(
        `${config.newApiGateway}/bill/customBillsettings`,
        {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            newBillsettings: updateSettingData,
            shopId: shopDetails.shopId,
            type: "post",
          }),
          method: "POST",
        }
      );
      const result = await response.json();
      console.log(result);
      if (result.statusCode === 200) {
        alert("Updated Successfully");
        dispatch({
          type: "INVOICE-NEWBILLSETTINGS",
          payload: customization,
        });
      }
    } catch (err) {
      alert("Error while updating settings!");
    } finally {
      onHide(false);
    }
  };

  const saveAdvanceSettings = async () => {
    try {
      const response = await fetch(
        `${config.newApiGateway}/bill/customBillsettings`,
        {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            type: "advanceSettings",
            advanceSettings,
          }),
          method: "POST",
        }
      );
      const result = await response.json();
      if (result.statusCode === 200) {
        alert("Updated Successfully");
        dispatch({
          type: "SET_ADVANCE_SETTINGS",
          payload: result.data.Attributes.advanceSettings,
        });
        if (!result.data.Attributes.advanceSettings?.b2bPricing) {
          setState((prev) => ({
            ...prev,
            b2bBill: false,
          }));
        }
        onHide(false);
      }
    } catch (error) {
      alert("Error while updating settings!");
    }
  };

  const handleSave = async () => {
    await saveAdvanceSettings();
    updateProductPriceWhileSwitching(false);
  };

  return (
    <div
      id="invoice-wrapper"
      style={{
        maxWidth: "-webkit-fill-available",
        maxWidth: "-moz-available",
        maxWidth: "fill-available",
        backgroundColor: "#F5F9FC",
      }}
    >
      <>
        {mode === "advance" && (
          <div
            style={{
              padding: "2rem",
            }}
          >
            <div
              style={{
                marginBottom: "0.5rem",
              }}
            >
              <Typography.Text strong>Input Setting</Typography.Text>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItem: "center",
                    gap: "0.5rem",
                    marginLeft: "24px",
                    cursor: "pointer",
                  }}
                >
                  <Checkbox
                    onClick={(e) => {
                      setAdvanceSettings((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.checked,
                      }));
                    }}
                    checked={advanceSettings.uniqueIdentity}
                    name="uniqueIdentity"
                    id="uniqueIdentity"
                  />
                  <label
                    style={{
                      cursor: "pointer",
                      marginBottom: 0,
                    }}
                    htmlFor="uniqueIdentity"
                  >
                    Alias{" "}
                    <span
                      style={{
                        fontSize: 14,
                      }}
                    >
                      (Flat no or Block no)
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div>
              <Typography.Text strong>Product Setting</Typography.Text>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItem: "center",
                    gap: "0.5rem",
                    marginLeft: "24px",
                    cursor: "pointer",
                  }}
                >
                  <Checkbox
                    onClick={(e) => {
                      setAdvanceSettings((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.checked,
                      }));
                    }}
                    checked={advanceSettings?.b2bPricing}
                    name="b2bPricing"
                    id="b2bPricing"
                  />
                  <label
                    style={{
                      cursor: "pointer",
                      marginBottom: 0,
                    }}
                    htmlFor="b2bPricing"
                  >
                    B2B pricing
                  </label>
                </div>
                <Button onClick={handleSave}>Save</Button>
              </div>
            </div>
          </div>
        )}
        {mode === "bill" && (
          <>
            {" "}
            <div className="INVOICE-container-table">
              <div className="INVOICE-invoice-left">
                <div className="INVOICE-invoice-left1">
                  <Title level={5}> Printer Settings</Title>
                  <div className="INVOICE-invoice-left2">
                    <div style={{ display: "flex" }}>
                      <div style={{ marginRight: "10px", fontWeight: 500 }}>
                        Printer Type:
                      </div>{" "}
                      <label
                        htmlFor="Thermal"
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <input
                          id="Thermal"
                          checked={Xerox.printerType === "Thermal"}
                          type="radio"
                          value="Thermal"
                          name="printerType"
                          style={{
                            accentColor: colorPrimary,
                          }}
                          onChange={(e) => updatePrint(e)}
                        />{" "}
                        Thermal{" "}
                      </label>
                      <label
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        htmlFor="A4"
                      >
                        <input
                          id="A4"
                          checked={Xerox.printerType === "A4"}
                          type="radio"
                          name="printerType"
                          value="A4"
                          style={{
                            accentColor: colorPrimary,
                          }}
                          onChange={(e) => updatePrint(e)}
                        />{" "}
                        A4{" "}
                      </label>
                    </div>
                  </div>
                  <div className="INVOICE-invoice-left2">
                    <div style={{ display: "flex" }}>
                      {Xerox.printerType === "Thermal" && (
                        <div>Paper Type:</div>
                      )}
                      {Xerox.printerType === "A4" && (
                        <div style={{ marginRight: "1px", fontWeight: 500 }}>
                          Paper Template:
                        </div>
                      )}

                      {Xerox.printerType === "Thermal" && (
                        <div>
                          {" "}
                          <label htmlFor="55" style={{ marginLeft: "16px" }}>
                            <input
                              id="55"
                              type="radio"
                              name="thermalPapertype"
                              value="55"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              checked={Xerox.thermalPapertype === "55"}
                              // onClick={() => setPrintetType("55")}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("55");
                              }}
                            />
                            55mm
                          </label>
                          <label htmlFor="80" style={{ marginLeft: "16px" }}>
                            {" "}
                            <input
                              id="80"
                              type="radio"
                              name="thermalPapertype"
                              value="80"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              checked={Xerox.thermalPapertype === "80"}
                              // onClick={() => setPrintetType("80")}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("80");
                              }}
                            />
                            80mm
                          </label>
                        </div>
                      )}
                      {Xerox.printerType === "A4" && (
                        <div className="printerType">
                          <label htmlFor="Elegant" className="Invoice-label">
                            <input
                              id="Elegant"
                              checked={Xerox.A4design === "Elegant"}
                              type="radio"
                              value="Elegant"
                              name="A4design"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("Classic");
                              }}
                            />
                            Elegant
                          </label>
                          <label htmlFor="Modern" className="Invoice-label">
                            <input
                              id="Modern"
                              type="radio"
                              checked={Xerox.A4design === "Modern"}
                              value="Modern"
                              name="A4design"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("Modern");
                              }}
                            />
                            Modern
                          </label>
                          <label htmlFor="Classic" className="Invoice-label">
                            <input
                              id="Classic"
                              type="radio"
                              checked={Xerox.A4design === "Classic"}
                              value="Classic"
                              name="A4design"
                              style={{ height: "16px", width: "16px" }}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("Elegant");
                              }}
                            />
                            Classic
                          </label>
                          <label htmlFor="Simple" className="Invoice-label">
                            <input
                              id="Simple"
                              checked={Xerox.A4design === "Simple"}
                              type="radio"
                              value="Simple"
                              name="A4design"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("Simple");
                              }}
                            />
                            Simple
                          </label>
                          <label htmlFor="Tabular" className="Invoice-label">
                            <input
                              id="Tabular"
                              checked={Xerox.A4design === "Tabular"}
                              type="radio"
                              value="Tabular"
                              name="A4design"
                              style={{
                                accentColor: colorPrimary,
                              }}
                              onChange={(e) => {
                                updatePrint(e);
                                // setPrintetType("Classic");
                              }}
                            />
                            Tabular
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="INVOICE-invoice-right">
                <div className="">
                  <Title level={5}> Text Editor</Title>
                  <div
                    style={{ gap: "16px", marginLeft: "24px", display: "flex" }}
                  >
                    {Xerox.printerType === "Thermal" && (
                      <div id="fontFamily">
                        <Select
                          value={Fonttype}
                          showSearch
                          placeholder="Select-Font-Type"
                          optionFilterProp="children"
                          onChange={onChange}
                          getPopupContainer={() =>
                            document.getElementById("fontFamily")
                          }
                        >
                          <Option value="'Besmoke', sans-serif">Default</Option>

                          <Option value="Helvetica">Helvetica</Option>
                          <Option value="Calibri">Calibri</Option>
                          <Option value="Futura"> Futura</Option>
                          <Option value="Garamond"> Garamond</Option>
                          <Option value="Times New Roman">
                            {" "}
                            Times New Roman
                          </Option>
                          <Option value="Arial"> Arial</Option>
                          <Option value="'Source Sans Pro',sans-serif">
                            {" "}
                            Source Sans Pro
                          </Option>
                          <Option value="Rockwell"> Rockwell</Option>
                          <Option value="Franklin Gothic">
                            {" "}
                            Franklin Gothic
                          </Option>
                        </Select>
                      </div>
                    )}
                    {Xerox.printerType === "A4" && (
                      <div id="fontFamilyA4">
                        <Select
                          value={A4Fonttype}
                          showSearch
                          placeholder="Select-Font-Type"
                          optionFilterProp="children1"
                          onChange={A4Onchange}
                          getPopupContainer={() =>
                            document.getElementById("fontFamilyA4")
                          }
                        >
                          <Option value="Helvetica">Helvetica</Option>
                          <Option value="Calibri">Calibri</Option>
                          <Option value="Futura"> Futura</Option>
                          <Option value="Garamond"> Garamond</Option>
                          <Option value="Times New Roman">
                            {" "}
                            Times New Roman
                          </Option>
                          <Option value="Arial"> Arial</Option>
                          <Option value="Verdana"> Verdana</Option>
                          <Option value="Rockwell"> Rockwell</Option>
                          <Option value="Franklin Gothic">
                            {" "}
                            Franklin Gothic
                          </Option>
                        </Select>
                      </div>
                    )}
                    {Xerox.printerType === "Thermal" && (
                      <div>
                        {Xerox.thermalPapertype === "55" && (
                          <div id="fontfamilSize">
                            <Select
                              value={T55fontsize}
                              placeholder="Thermal-Font-Size"
                              onChange={ThermalFontSize55}
                              getPopupContainer={() =>
                                document.getElementById("fontfamilSize")
                              }
                            >
                              <Option value="11px">Small</Option>

                              <Option value="12px">Medium</Option>

                              <Option value="13px">Large</Option>
                            </Select>
                          </div>
                        )}
                        {Xerox.thermalPapertype === "80" && (
                          <div id="fontfamilSize80">
                            <Select
                              value={T80fontsize}
                              placeholder="Thermal-Font-Size"
                              onChange={ThermalFontSize88}
                              getPopupContainer={() =>
                                document.getElementById("fontfamilSize80")
                              }
                            >
                              <Option value="13px">Small</Option>

                              <Option value="14px">Medium</Option>

                              <Option value="16px">Large</Option>
                            </Select>
                          </div>
                        )}
                      </div>
                    )}

                    {Xerox.printerType === "A4" && (
                      <div id="fontfamilSizeA4">
                        <Select
                          value={A4fontsize}
                          placeholder="A4-Font-Size"
                          onChange={A4FontSizes}
                          getPopupContainer={() =>
                            document.getElementById("fontfamilSizeA4")
                          }
                        >
                          <Option value="14px">Small</Option>
                          <Option value="16px">Medium</Option>
                          <Option value="18px">Large</Option>
                        </Select>
                      </div>
                    )}
                    {Xerox.printerType === "A4" && (
                      <div
                        ref={stickerref}
                        style={{
                          position: "relative",
                        }}
                      >
                        {hidden === true && (
                          <SketchPicker
                            styles={pickerStyles}
                            color={color}
                            onChange={(updateColor) =>
                              setColor(updateColor.hex)
                            }
                          />
                        )}
                        <button
                          style={{
                            border: "1px solid #dbd0d0",
                            height: "33px",
                            width: "100px",
                            backgroundColor: "white",
                          }}
                          onClick={() => setHidden(true)}
                        >
                          Color
                          {/* {hidden?"close color picker":"Open color picker"} */}
                          <button
                            type="checkbox"
                            style={{
                              backgroundColor: color,
                              border: "1px solid black",
                              height: "17px",
                              marginLeft: "10px",
                            }}
                          />
                        </button>
                      </div>
                    )}
                    {showButton === true && (
                      <div
                        style={{
                          position: "relative",
                        }}
                      >
                        {/* <Affix offsetTop={top}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setTop(top + 10);
                        callback.current.click();
                      }}
                      ref={fcallback}
                    >
                      Save
                    </Button>
                  </Affix> */}

                        {changeButton === false && (
                          <button
                            class="button-1"
                            onClick={() => {
                              callback.current.click();
                              setchangeButtoon(true);

                              onHide(false);
                              // notification.open({
                              //   message: (
                              //     <div
                              //       style={{
                              //         color: "#007bff",
                              //         fontWeight: "900",
                              //       }}
                              //     >
                              //       Changes Saved.....
                              //     </div>
                              //   ),
                              //   duration: 0.5,

                              //   description: "",
                              //   onClick: () => {
                              //     console.log("Notification Clicked!");
                              //   },
                              // });
                            }}
                            ref={fcallback}
                          >
                            Save
                          </button>
                        )}
                        {changeButton === true && (
                          <button
                            class="button-1"
                            style={{ backgroundColor: "#2EFF2E" }}
                          >
                            Saving....
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* A4,Thermal----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            <div style={{ width: "100%", display: "flex", marginTop: "-15px" }}>
              <div style={{ width: "60%" }}>
                {/* simple design------------------------------------------------------------------------------------- */}
                {Xerox.printerType === "A4" && (
                  <div>
                    {Xerox.A4design === "Simple" && (
                      <div>
                        <div className="INVOICE-SIDEBAR-container4">
                          <div
                            className="INVOICE-SIDEBAR-menu-template1"
                            style={{ marginTop: "50px" }}
                          >
                            <div id="divToPrint">
                              <div
                                className="Classic-A4-design"
                                style={{
                                  fontFamily: A4Fonttype,
                                  fontSize: "14px",
                                }}
                              >
                                {/* fontSize:A4fontsize */}
                                <div
                                  className="Modern-Header"
                                  style={{
                                    fontSize: "12px",
                                    fontfamily: "rubik",
                                  }}
                                >
                                  <div
                                    className="Modern-Header-top Simple-Head"
                                    style={{ display: "flex", width: "100%" }}
                                  >
                                    <div
                                      className="Modern-Header-top-left"
                                      style={{
                                        width: "60%",
                                        paddingLeft: "0px",
                                      }}
                                    >
                                      <div
                                        className="Simple-Header-right-title"
                                        style={{ color: color }}
                                      >
                                        {" "}
                                        {customization.shoplogo && (
                                          <div style={{ float: "left" }}>
                                            {shopDetails.shopIconLocation !==
                                              "removed" &&
                                              " " && (
                                                <img
                                                  src={
                                                    shopDetails.shopIconLocation
                                                  }
                                                  alt="shop icon"
                                                  style={{
                                                    width: "56px",
                                                    height: "56px",
                                                    paddingLeft: "5px",
                                                    borderRadius: "12px",
                                                  }}
                                                />
                                              )}
                                          </div>
                                        )}
                                        {shopDetails.shopName}
                                      </div>

                                      <div
                                        className="Classic-body-bot-left-content"
                                        style={{
                                          marginLeft: "56px",
                                          margintop: "-13px",
                                        }}
                                      >
                                        <p style={{ fontSize: "14px" }}>
                                          Mobile:{shopDetails.shopPhoneNumber}
                                        </p>

                                        <p>
                                          {shopDetails.websiteUrl && (
                                            <div>
                                              {customization.ShopURL && (
                                                <div>
                                                  {" "}
                                                  {shopDetails.customDomainUrl
                                                    ? shopDetails.customDomainUrl
                                                    : shopDetails.websiteUrl}
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="Modern-Header-top-right"
                                      style={{
                                        width: "40%",
                                        textAlign: "right",
                                        paddingTop: "14px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "16px",
                                          color: "#3F3F3F",
                                          width: "0px",
                                          marginLeft: "auto",
                                          marginRight: "86px",
                                        }}
                                      >
                                        Tax_Invoice
                                      </div>
                                      {console.log(
                                        "customization simple",
                                        customization
                                      )}
                                      {customization.ShopAddress && (
                                        <div style={{ paddingTop: "5px" }}>
                                          <div style={{}}>
                                            <p>{shopDetails.shopAddress}</p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className="Modern-Header-bot"
                                    style={{
                                      display: "flex",
                                      borderTop: "1px solid #000000",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div className="Simple-Header-bot-first">
                                      <div className="Elegant-address-rig">
                                        <h1>Invoice Details</h1>
                                        <li>
                                          Invoice No:
                                          {customization.invoicePrefixtext}
                                          {customization.invoiceSuffixtext}
                                        </li>
                                        <li>
                                          Invoice Date:
                                          {new Date()
                                            .toISOString()
                                            .substring(0, 10)}
                                        </li>
                                        {/* <li>Due Date:25-Aug-2021</li> */}
                                      </div>
                                    </div>
                                    <div className="Simple-Header-bot-first">
                                      <div className="Elegant-address-rig">
                                        <h1>Billed To.</h1>
                                        {customization.customerprivacy && (
                                          <div>
                                            <li>Customer Name</li>
                                          </div>
                                        )}

                                        {customization.deliveryaddress && (
                                          <li>
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </li>
                                        )}
                                      </div>
                                    </div>

                                    {customization.deliveryaddress && (
                                      <div className="Simple-Header-bot-first">
                                        <div>
                                          <h1>Shipping To</h1>

                                          <li>
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </li>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <hr style={{ margin: "0px", padding: "0px" }} />
                                <div
                                  className="Classic-Body"
                                  style={{ fontSize: "12px" }}
                                >
                                  <div className="Simple-Body-top">
                                    <table style={{ width: "100%" }}>
                                      <thead>
                                        <tr
                                          style={{
                                            textAlign: "center",
                                            height: "35px",
                                          }}
                                        >
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            S.no
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Items
                                          </th>

                                          {shopDetails.shopType === "Mobile" &&
                                            customization.imei1imei2 && (
                                              <th
                                                style={{
                                                  backgroundColor: color,
                                                }}
                                              >
                                                IMEI1/IMEI2
                                              </th>
                                            )}
                                          {customization.hsncode && (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              HSN
                                            </th>
                                          )}
                                          {customization.itemmrp && (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              MRP
                                            </th>
                                          )}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Qty
                                          </th>
                                          {customization.itemdiscount && (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Disc
                                            </th>
                                          )}
                                          {customization.itemleveltax && (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Tax(%)
                                            </th>
                                          )}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Rate
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dummy.map((value, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>{value.SNo}</td>
                                              <td style={{ textAlign: "left" }}>
                                                {customization.variant ? (
                                                  <>
                                                    {value.items}-
                                                    {value.variant}
                                                  </>
                                                ) : (
                                                  value.items
                                                )}
                                              </td>

                                              {shopDetails.shopType ===
                                                "Mobile" &&
                                                customization.imei1imei2 && (
                                                  <td>{value.IMEI}</td>
                                                )}
                                              {customization.hsncode && (
                                                <td>{value.HSN}</td>
                                              )}
                                              {customization.itemmrp && (
                                                <td>{value.MRP}</td>
                                              )}
                                              <td>{value.Qty}</td>
                                              {customization.itemdiscount && (
                                                <td>{value.Dics}</td>
                                              )}
                                              {customization.itemleveltax && (
                                                <td>{value.Tax}</td>
                                              )}
                                              <td>{value.Rate}</td>
                                              <td>{value.Amount}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                  <hr
                                    style={{
                                      border: "0.2px solid #000000",
                                      marginTop: "16px",
                                    }}
                                  />
                                  <div style={{ display: "flex" }}>
                                    <div style={{ width: "60%" }}></div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "103px",
                                        width: "40%",
                                      }}
                                    >
                                      <div>Subtotal</div>
                                      <div>56779768</div>
                                    </div>
                                  </div>

                                  <hr
                                    style={{
                                      border: "0.2px solid #000000",
                                      marginBottom: "4px",
                                    }}
                                  />
                                  <div
                                    className="Classic-Body-bot"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <div className="Classic-body-bot-left">
                                      {customization.notes && (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Notes:
                                          </div>
                                          <div>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit. liquam
                                            lacus ac elementum mi egestas dui
                                            sed lacus, pharetra.
                                          </div>
                                        </div>
                                      )}

                                      {customization.paymenyterms && (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Payment Terms:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.paymentTermsField}{" "}
                                          </div>
                                        </div>
                                      )}
                                      {/* {customization.duedate && (
                              <div className="Classic-body-bot-left-content">
                                <div>Due Date:25-Aug-2021</div>
                              </div>
                            )} */}
                                      {/* {customization.invoiceprefix && (
                                  <div className="Classic-body-bot-left-content">
                                    <div>
                                      <strong>Invoice Prefix:</strong>
                                      {Invoicetext.invoicePrefixtext}{" "}
                                    </div>
                                  </div>
                                )} */}
                                      {customization.termscondition && (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Terms and Conditions:
                                          </div>
                                          <p>
                                            <li
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {Invoicetext.tAndCField}
                                            </li>
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="Classic-body-bot-right">
                                      <div className="Modern-body-bot-righ-top">
                                        <div className="Elegant-body-bot-righ-top-top">
                                          <div
                                            className="Classic-body-bot-righ-top-top-title Elegant-li"
                                            style={{}}
                                          >
                                            {customization.adddiscount && (
                                              <li>Discount</li>
                                            )}
                                            <li>Coupon</li>
                                            {customization.othercharges && (
                                              <li>Charges</li>
                                            )}
                                            <hr
                                              style={{
                                                border: "0.5px solid #3F3F3F",
                                              }}
                                            />
                                            <li>Total Amount</li>
                                          </div>
                                          <div
                                            className="Classic-body-bot-righ-top-top-price Elegant-li"
                                            style={{}}
                                          >
                                            {customization.adddiscount && (
                                              <li>7869870</li>
                                            )}
                                            <li>Coupon</li>

                                            {customization.othercharges && (
                                              <li>7869870</li>
                                            )}
                                            <hr
                                              style={{
                                                border: "0.5px solid #3F3F3F",
                                              }}
                                            />
                                            <li style={{ color: "#EF4667" }}>
                                              3238328
                                            </li>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="Classic-body-bot-righ-mid"
                                        style={{
                                          display: "flex",
                                          marginLeft: "11px",
                                          marginRight: "-11px",
                                        }}
                                      >
                                        <div
                                          className="Classic-body-bot-righ-mid-first"
                                          style={{}}
                                        >
                                          <div>Amount Paid</div>
                                          <hr
                                            style={{
                                              border: "0.5px solid #3F3F3F",
                                              marginLeft: "78px",
                                            }}
                                          />
                                          <div>Amount Due</div>
                                        </div>
                                        <div
                                          className="Classic-body-bot-righ-mid-second"
                                          style={{}}
                                        >
                                          <div>2000000</div>
                                          <hr
                                            style={{
                                              border: "0.5px solid #3F3F3F",
                                            }}
                                          />
                                          <div>
                                            <strong>5000000</strong>
                                          </div>
                                        </div>
                                      </div>
                                      <hr
                                        style={{
                                          marginLeft: "76px",
                                          marginTop: "0px",
                                          marginBottom: "0px",
                                          bordertop: "2px solid",
                                        }}
                                      />
                                      <div className="Classic-body-bot-righ-bot">
                                        <div>
                                          <strong>Total in Words</strong>
                                        </div>
                                        <div>
                                          Two Laks Fifty Thouand Rupees only
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {customization.ghoshaklogo && (
                                  <div
                                    className="Classic-footer-A4"
                                    style={{
                                      width: "500px",
                                      marginLeft: "45px",
                                      marginTop: "0px",
                                      fontSize: "10PX",
                                      backgroundColor: color,
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "400",
                                        backgroundColor: color,
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <div
                                        style={{ marginLeft: "59px" }}
                                        className="Classic-footer-A4-fooert-content"
                                      >
                                        Generate professional invoice using
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-1">
                                        <img
                                          src={Logo_Original}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                          }}
                                        />
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-2">
                                        Business app
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-3">
                                        <img
                                          src={Google}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                            marginLeft: "4px",
                                            marginTop: "11px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb5">
                              {/* <button onClick={printDocument}>Print</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* classic design -------------------------------------------------------------------------------------- */}
                    {Xerox.A4design === "Classic" && (
                      <div>
                        {" "}
                        <div className="INVOICE-SIDEBAR-container4">
                          <div
                            className="INVOICE-SIDEBAR-menu-template1"
                            style={{ marginTop: "50px" }}
                          >
                            <div id="divToPrint">
                              <div
                                className="Classic-A4-design"
                                style={{
                                  fontSize: "14px",
                                  fontFamily: A4Fonttype,
                                }}
                              >
                                <div
                                  className="Classic-Header"
                                  style={{ fontfamily: "rubik" }}
                                >
                                  <div className="Classic-Header-left">
                                    <div className="Classic-Header-left-top">
                                      <div>
                                        <strong>Invoice Number</strong>
                                      </div>
                                      <div>
                                        {customization.invoicePrefixtext}
                                        {customization.invoiceSuffixtext}
                                      </div>
                                    </div>
                                    <div className="Classic-Header-left-mid">
                                      {customization.customerprivacy && (
                                        <div>
                                          <div style={{ fontWeight: 600 }}>
                                            Invoice To.
                                          </div>

                                          <div>Customer Name.</div>
                                        </div>
                                      )}
                                      {customization.customerprivacy && (
                                        <div>Phone no</div>
                                      )}
                                    </div>
                                    <div className="Classic-Header-left-bot">
                                      <div style={{ paddingBottom: "2px" }}>
                                        <div style={{ fontWeight: 600 }}>
                                          Invoice Date:
                                        </div>
                                        <div>
                                          {new Date()
                                            .toISOString()
                                            .substring(0, 10)}
                                        </div>
                                      </div>
                                      {/* <div>
                              {customization.duedate && <div>Due Date:</div>}
                              {customization.duedate && <div>25-Aug-2001</div>}
                            </div> */}
                                    </div>
                                  </div>
                                  <div className="Classic-Header-right">
                                    <div style={{ marginTop: "25px" }}>
                                      {customization.shoplogo && (
                                        <div>
                                          {shopDetails.shopIconLocation !==
                                            "removed" &&
                                            " " && (
                                              <img
                                                src={
                                                  shopDetails.shopIconLocation
                                                }
                                                alt="shop icon"
                                                style={{
                                                  width: "56px",
                                                  height: "56px",
                                                  paddingLeft: "5px",
                                                  borderRadius: "12px",
                                                }}
                                              />
                                            )}
                                        </div>
                                      )}
                                      <div
                                        className="Classic-Header-right-title"
                                        style={{
                                          color: color,
                                          fontSize: "20px",
                                        }}
                                      >
                                        {shopDetails.shopName}
                                      </div>
                                      {shopDetails.websiteUrl && (
                                        <div>
                                          {customization.ShopURL && (
                                            <div>
                                              {" "}
                                              {shopDetails.customDomainUrl
                                                ? shopDetails.customDomainUrl
                                                : shopDetails.websiteUrl}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      <div className="Classic-header-right-content">
                                        <p>
                                          Mobile:{shopDetails.shopPhoneNumber}
                                        </p>
                                        <p>
                                          {customization.ShopAddress && (
                                            <p>{shopDetails.shopAddress}</p>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <hr style={{ margin: "0px", padding: "0px" }} />
                                <div className="Classic-Body" style={{}}>
                                  <div className="Classic-Body-top">
                                    <table style={{ width: "100%" }}>
                                      <thead>
                                        <tr style={{ textAlign: "center" }}>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            S.no
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Items
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Qty
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Rate
                                          </th>
                                          {customization.itemmrp ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              MRP
                                            </th>
                                          ) : null}
                                          {customization.hsncode ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              HSN
                                            </th>
                                          ) : null}

                                          {shopDetails.shopType === "Mobile" &&
                                            customization.imei1imei2 && (
                                              <th
                                                style={{
                                                  backgroundColor: color,
                                                }}
                                              >
                                                IMEI1/IMEI2
                                              </th>
                                            )}
                                          {customization.itemdiscount ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Disc
                                            </th>
                                          ) : null}
                                          {customization.itemleveltax ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Tax(%)
                                            </th>
                                          ) : null}

                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dummy.map((value, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>{value.SNo}</td>
                                              <td style={{ textAlign: "left" }}>
                                                {customization.variant ? (
                                                  <>
                                                    {value.items}-
                                                    {value.variant}
                                                  </>
                                                ) : (
                                                  value.items
                                                )}
                                              </td>
                                              <td>{value.Qty}</td>
                                              <td>{value.Rate}</td>
                                              {customization.hsncode ? (
                                                <td>{value.HSN}</td>
                                              ) : null}
                                              {customization.itemmrp ? (
                                                <td>{value.MRP}</td>
                                              ) : null}

                                              {shopDetails.shopType ===
                                                "Mobile" &&
                                              customization.imei1imei2 ? (
                                                <td>{value.IMEI}</td>
                                              ) : null}

                                              {customization.itemdiscount ? (
                                                <td>{value.Dics}</td>
                                              ) : null}
                                              {customization.itemleveltax ? (
                                                <td>{value.Tax}</td>
                                              ) : null}

                                              <td>{value.Amount}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="Classic-Body-bot" style={{}}>
                                    <div className="Classic-body-bot-left">
                                      {customization.notes && (
                                        <div className="Classic-body-bot-left-content">
                                          <div>
                                            {" "}
                                            <strong>Notes:</strong>
                                          </div>
                                          <div>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit. liquam
                                            lacus ac elementum mi egestas dui
                                            sed lacus, pharetra.
                                          </div>
                                        </div>
                                      )}
                                      {customization.termscondition ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Terms and Conditions:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.tAndCField}
                                          </div>
                                        </div>
                                      ) : null}
                                      {customization.paymenyterms ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Payment Terms:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.paymentTermsField}{" "}
                                          </div>
                                        </div>
                                      ) : null}
                                      {customization.deliveryaddress && (
                                        <div className="Classic-body-bot-left-content">
                                          <div>
                                            <strong>Delivery To</strong>
                                          </div>
                                          <div>
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </div>
                                        </div>
                                      )}
                                      {/* {customization.invoiceprefix ? (
                                  <div className="Classic-body-bot-left-content">
                                    <div>
                                      <strong>Invoice Prefix:</strong>
                                      {Invoicetext.invoicePrefixtext}{" "}
                                    </div>
                                  </div>
                                ) : null} */}
                                    </div>
                                    <div className="Classic-body-bot-right">
                                      <div className="Classic-body-bot-righ-top">
                                        <div className="Classic-body-bot-righ-top-top">
                                          <div className="Classic-body-bot-righ-top-top-title">
                                            <li>Subtotal</li>
                                            {customization.adddiscount ? (
                                              <li>Discount</li>
                                            ) : null}

                                            <li>Coupon </li>

                                            {customization.othercharges ? (
                                              <li>Charges</li>
                                            ) : null}
                                            <li>Total Amount</li>
                                          </div>
                                          <div className="Classic-body-bot-righ-top-top-price">
                                            <li>S200000</li>
                                            {customization.adddiscount ? (
                                              <li>4657</li>
                                            ) : null}
                                            <li>2387328</li>

                                            {customization.othercharges ? (
                                              <li>10</li>
                                            ) : null}
                                            <li style={{ color: "#EF4667" }}>
                                              3238328
                                            </li>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="Classic-body-bot-righ-mid"
                                        style={{ display: "flex" }}
                                      >
                                        <div
                                          className="Classic-body-bot-righ-mid-first"
                                          style={{}}
                                        >
                                          <div>Amount Paid:</div>
                                          <div>Balance Paid:</div>
                                          <div>Amount Due</div>
                                        </div>
                                        <div
                                          className="Classic-body-bot-righ-mid-second"
                                          style={{}}
                                        >
                                          <div>2000000</div>
                                          <div>5757</div>
                                          <div>
                                            <strong>5000000</strong>
                                          </div>
                                        </div>
                                      </div>
                                      <hr
                                        style={{
                                          marginLeft: "76px",
                                          marginTop: "0px",
                                          marginBottom: "0px",
                                          bordertop: "2px solid",
                                        }}
                                      />
                                      <div className="Classic-body-bot-righ-bot">
                                        <div>
                                          <strong>
                                            Available Loyalty Pts:
                                          </strong>
                                        </div>
                                        <div>250</div>
                                        <div>
                                          <strong>Total in Words:</strong>
                                        </div>
                                        <div>
                                          Two Laks Fifty Thouand Rupees only
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {customization.ghoshaklogo && (
                                  <div
                                    className="Classic-footer-A4"
                                    style={{
                                      width: "500px",
                                      marginLeft: "45px",
                                      marginTop: "40px",
                                      fontSize: "10PX",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "400",
                                        backgroundColor: color,
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <div
                                        style={{ marginLeft: "59px" }}
                                        className="Classic-footer-A4-fooert-content"
                                      >
                                        Generate professional invoice using
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-1">
                                        <img
                                          src={Logo_Original}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                          }}
                                        />
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-2">
                                        Business app
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-3">
                                        <img
                                          src={Google}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                            marginLeft: "4px",
                                            marginTop: "11px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb5">
                              {/* <button onClick={printDocument}>Print</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {Xerox.A4design === "Modern" && (
                      <div>
                        <div className="INVOICE-SIDEBAR-container4">
                          <div
                            className="INVOICE-SIDEBAR-menu-template1"
                            style={{ marginTop: "50px" }}
                          >
                            <div id="divToPrint">
                              <div
                                className="Classic-A4-design"
                                style={{
                                  fontSize: "14px",
                                  fontFamily: A4Fonttype,
                                }}
                              >
                                <div
                                  className="Modern-Header"
                                  style={{
                                    fontSize: "12px",
                                    fontfamily: "rubik",
                                  }}
                                >
                                  <div
                                    className="Modern-Header-top"
                                    style={{ display: "flex", width: "100%" }}
                                  >
                                    <div
                                      className="Modern-Header-top-left"
                                      style={{ width: "50%" }}
                                    >
                                      {customization.shoplogo && (
                                        <div>
                                          {shopDetails.shopIconLocation !==
                                            "removed" &&
                                            " " && (
                                              <img
                                                src={
                                                  shopDetails.shopIconLocation
                                                }
                                                alt="shop icon"
                                                style={{
                                                  width: "56px",
                                                  height: "56px",
                                                  paddingLeft: "5px",
                                                  borderRadius: "12px",
                                                }}
                                              />
                                            )}
                                        </div>
                                      )}
                                      <div
                                        className="Classic-Header-right-title"
                                        style={{
                                          fontSize: "20px",
                                          fontFamily: A4Fonttype,
                                          color: color,
                                          float: "left",
                                        }}
                                      >
                                        {" "}
                                        {shopDetails.shopName}
                                      </div>
                                    </div>
                                    <div
                                      className="Modern-Header-top-right"
                                      style={{
                                        width: "50%",
                                        textAlign: "right",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "30px",
                                          lineHeight: "36px",
                                          color: "#3F3F3F",
                                          backgroundColor: "#F3F3F3",
                                          borderRadius: "0px 0px 0px 35px",
                                          width: "220px",
                                          marginLeft: "auto",
                                        }}
                                      >
                                        Invoice
                                      </div>
                                      <div style={{ paddingTop: "5px" }}>
                                        <p>{shopDetails.shopPhoneNumber} </p>
                                        <p>
                                          {shopDetails.websiteUrl && (
                                            <div>
                                              {customization.ShopURL && (
                                                <div>
                                                  {" "}
                                                  {shopDetails.customDomainUrl
                                                    ? shopDetails.customDomainUrl
                                                    : shopDetails.websiteUrl}
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </p>
                                        {customization.ShopAddress && (
                                          <p>{shopDetails.shopAddress}</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="Modern-Header-bot"
                                    style={{ display: "flex" }}
                                  >
                                    <div className="Modern-Header-bot-first">
                                      <div className="Modern-Header-bot-sec">
                                        <h1>Invoice Details</h1>
                                        <li>
                                          Invoice No:
                                          {customization.invoicePrefixtext}
                                          {customization.invoiceSuffixtext}
                                        </li>
                                        <li>
                                          Invoice Date:
                                          {new Date()
                                            .toISOString()
                                            .substring(0, 10)}
                                        </li>
                                        {/* <li>Due Date:25-jun-2021</li> */}
                                      </div>
                                    </div>
                                    {customization.customerprivacy ? (
                                      <div
                                        className="Modern-Header-bot-first"
                                        style={{ borderLeft: "2px" }}
                                      >
                                        <div className="Modern-Header-bot-thi">
                                          {customization.customerprivacy ? (
                                            <div>
                                              <h1>Invoice To.</h1>
                                              <li>Customer Name</li>
                                            </div>
                                          ) : null}
                                          {customization.customerprivacy ? (
                                            <li>Phone No:2345679231</li>
                                          ) : null}
                                          {customization.deliveryaddress ? (
                                            <li>
                                              No:16,BV 2nd street, Chennai -
                                              600011.
                                            </li>
                                          ) : null}
                                        </div>
                                      </div>
                                    ) : null}
                                    {customization.deliveryaddress ? (
                                      <div className="Modern-Header-bot-first">
                                        <div className="Modern-Header-bot-thi">
                                          <h1>Shipping To</h1>

                                          <li>
                                            No:16,BV 2nd street,Chennai -
                                            600011.
                                          </li>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <hr style={{ margin: "0px", padding: "0px" }} />
                                <div
                                  className="Classic-Body"
                                  style={{ fontSize: "12px" }}
                                >
                                  <div className="Modern-Body-top">
                                    <table style={{ width: "100%" }}>
                                      <thead>
                                        <tr style={{ textAlign: "center" }}>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            S.no
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Items
                                          </th>
                                          {shopDetails.shopType === "Mobile" &&
                                          customization.imei1imei2 ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              IMEI1/IMEI2
                                            </th>
                                          ) : null}

                                          {customization.hsncode ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              HSN
                                            </th>
                                          ) : null}
                                          {customization.itemmrp ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              MRP
                                            </th>
                                          ) : null}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Qty
                                          </th>
                                          {customization.itemdiscount ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Disc
                                            </th>
                                          ) : null}
                                          {customization.itemleveltax ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Tax(%)
                                            </th>
                                          ) : null}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Rate
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dummy.map((value, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>{value.SNo}</td>
                                              <td style={{ textAlign: "left" }}>
                                                {customization.variant ? (
                                                  <>
                                                    {value.items}-
                                                    {value.variant}
                                                  </>
                                                ) : (
                                                  value.items
                                                )}
                                              </td>

                                              {shopDetails.shopType ===
                                                "Mobile" &&
                                              customization.imei1imei2 ? (
                                                <td>{value.IMEI}</td>
                                              ) : null}

                                              {customization.hsncode ? (
                                                <td>{value.HSN}</td>
                                              ) : null}
                                              {customization.itemmrp ? (
                                                <td>{value.MRP}</td>
                                              ) : null}
                                              <td>{value.Qty}</td>
                                              {customization.itemdiscount ? (
                                                <td>{value.Dics}</td>
                                              ) : null}
                                              {customization.itemleveltax ? (
                                                <td>{value.Tax}</td>
                                              ) : null}
                                              <td>{value.Rate}</td>
                                              <td>{value.Amount}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div
                                    className="Classic-Body-bot"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <div className="Classic-body-bot-left">
                                      {customization.notes && (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Notes:
                                          </div>
                                          <div>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit. liquam
                                            lacus ac elementum mi egestas dui
                                            sed lacus, pharetra.
                                          </div>
                                        </div>
                                      )}
                                      {customization.termscondition ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Terms and Conditions:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.tAndCField}
                                          </div>
                                        </div>
                                      ) : null}
                                      {customization.paymenyterms ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Payment Terms:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.paymentTermsField}{" "}
                                          </div>
                                        </div>
                                      ) : null}
                                      {/* {customization.duedate?<div className='Classic-body-bot-left-content'>
  <h3>Due Date:25-Aug-2021</h3>
  
</div>:null} */}
                                      {/* {customization.invoiceprefix ? (
                                  <div className="Classic-body-bot-left-content">
                                    <div>
                                      <strong>Invoice Prefix:</strong>
                                      {Invoicetext.invoicePrefixtext}{" "}
                                    </div>
                                  </div>
                                ) : null} */}
                                      {/* <div className='Classic-body-bot-left-content Modern-thanks'><h3>Thank you for Business ,visit us again.</h3>
                <p>3/23, Manivel Nagar, Thousand Lights west, Uthamar Gandhi Salai, Thiruvanmiyur, 
Chennai - 600024 </p></div> */}
                                    </div>
                                    <div className="Classic-body-bot-right">
                                      <div className="Modern-body-bot-righ-top">
                                        <div className="Classic-body-bot-righ-top-top">
                                          <div
                                            className="Classic-body-bot-righ-top-top-title Modern-li"
                                            style={{
                                              backgroundColor: " #F3F3F3",
                                              borderLeft: " 1px solid #3F3F3F",
                                              borderBottom:
                                                " 1px solid #3F3F3F",
                                            }}
                                          >
                                            <li>Subtotal</li>
                                            {customization.adddiscount ? (
                                              <li>Discount</li>
                                            ) : null}
                                            <li>Coupon</li>
                                            {/* <li>Taxable Amount</li>
                  <li>CGST@7%</li>
                  <li>SGST@%</li>
                  <li>Packing Chargers</li> */}
                                            {/* <li>Delivery Charges</li> */}
                                            {customization.othercharges ? (
                                              <li>Charges</li>
                                            ) : null}
                                            <li>Total Amount</li>
                                          </div>
                                          <div
                                            className="Classic-body-bot-righ-top-top-price Modern-li"
                                            style={{
                                              backgroundColor: "#E5E5E5",
                                              borderLeft: " 1px solid #3F3F3F",
                                              borderRight: " 1px solid #3F3F3F",
                                              borderBottom:
                                                " 1px solid #3F3F3F",
                                            }}
                                          >
                                            <li>S200000</li>
                                            {customization.adddiscount ? (
                                              <li>7869870</li>
                                            ) : null}
                                            <li>Coupon</li>
                                            {/* <li>2387328</li>
                  <li>3238328</li>
                  <li>3238328</li>
                  <li>3238328</li> */}
                                            {/* <li>3238328</li> */}
                                            {customization.othercharges ? (
                                              <li>7869870</li>
                                            ) : null}
                                            <li style={{ color: "#EF4667" }}>
                                              3238328
                                            </li>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="Classic-body-bot-righ-mid"
                                        style={{ display: "flex" }}
                                      >
                                        <div
                                          className="Classic-body-bot-righ-mid-first"
                                          style={{}}
                                        >
                                          <div>Amount Paid</div>
                                          <div>Amount Due</div>
                                        </div>
                                        <div
                                          className="Classic-body-bot-righ-mid-second"
                                          style={{}}
                                        >
                                          <div>2000000</div>
                                          <div>
                                            <strong>5000000</strong>
                                          </div>
                                        </div>
                                      </div>
                                      <hr
                                        style={{
                                          marginLeft: "76px",
                                          marginTop: "0px",
                                          marginBottom: "0px",
                                          bordertop: "2px solid",
                                        }}
                                      />
                                      <div className="Classic-body-bot-righ-bot">
                                        <div>
                                          <strong>Total in Words</strong>
                                        </div>
                                        <div>
                                          Two Laks Fifty Thouand Rupees only
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {customization.ghoshaklogo && (
                                  <div
                                    className="Classic-footer-A4"
                                    style={{
                                      width: "500px",
                                      marginLeft: "45px",
                                      marginTop: "0px",
                                      fontSize: "10PX",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "400",
                                        backgroundColor: color,
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <div
                                        style={{ marginLeft: "59px" }}
                                        className="Classic-footer-A4-fooert-content"
                                      >
                                        Generate professional invoice using
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-1">
                                        <img
                                          src={Logo_Original}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                          }}
                                        />
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-2">
                                        Business app
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-3">
                                        <img
                                          src={Google}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                            marginLeft: "4px",
                                            marginTop: "11px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb5">
                              {/* <button onClick={printDocument}>Print</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {Xerox.A4design === "Elegant" && (
                      <div>
                        {" "}
                        <div className="INVOICE-SIDEBAR-container4">
                          <div
                            className="INVOICE-SIDEBAR-menu-template1"
                            style={{ marginTop: "50px" }}
                          >
                            <div id="divToPrint">
                              <div
                                className="Classic-A4-design"
                                style={{
                                  fontSize: "14px",
                                  fontFamily: A4Fonttype,
                                }}
                              >
                                <div
                                  className="Modern-Header"
                                  style={{
                                    fontSize: "12px",
                                    fontfamily: "rubik",
                                  }}
                                >
                                  <div
                                    className="Modern-Header-top"
                                    style={{ display: "flex", width: "100%" }}
                                  >
                                    <div
                                      className="Modern-Header-top-left"
                                      style={{
                                        width: "60%",
                                        paddingLeft: "0px",
                                      }}
                                    >
                                      <div
                                        className="Classic-Header-right-title"
                                        style={{
                                          color: color,
                                          fontSize: "20px",
                                          fontFamily: A4Fonttype,
                                          height: "58px",
                                          display: "flex",
                                        }}
                                      >
                                        {" "}
                                        {customization.shoplogo && (
                                          <div>
                                            {shopDetails.shopIconLocation !==
                                              "removed" &&
                                              " " && (
                                                <img
                                                  src={
                                                    shopDetails.shopIconLocation
                                                  }
                                                  alt="shop icon"
                                                  style={{
                                                    width: "56px",
                                                    height: "56px",
                                                    paddingLeft: "5px",
                                                    borderRadius: "12px",
                                                  }}
                                                />
                                              )}
                                          </div>
                                        )}
                                        <div
                                          style={{
                                            textAlign: "left",
                                            fontSize: "20px",
                                          }}
                                        >
                                          {shopDetails.shopName}
                                        </div>
                                      </div>

                                      <div
                                        className="Classic-body-bot-left-content"
                                        style={{
                                          margintop: "-10px",
                                        }}
                                      >
                                        <p>{shopDetails.shopPhoneNumber}</p>
                                        {customization.ShopAddress && (
                                          <p>{shopDetails.shopAddress}</p>
                                        )}
                                        <p>
                                          {shopDetails.websiteUrl && (
                                            <div>
                                              {customization.ShopURL && (
                                                <div>
                                                  {" "}
                                                  {shopDetails.customDomainUrl
                                                    ? shopDetails.customDomainUrl
                                                    : shopDetails.websiteUrl}
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="Modern-Header-top-right"
                                      style={{
                                        width: "40%",
                                        textAlign: "right",
                                        paddingTop: "14px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "16px",
                                          color: "#3F3F3F",
                                          width: "0px",
                                          marginLeft: "auto",
                                          marginRight: "54px",
                                        }}
                                      >
                                        Invoice
                                      </div>
                                      <div style={{ paddingTop: "5px" }}>
                                        <div style={{}}>
                                          <li>
                                            <strong>Invoice No:</strong>
                                            {customization.invoicePrefixtext}
                                            {customization.invoiceSuffixtext}
                                          </li>

                                          <li>
                                            <strong>Invoice Date:</strong>
                                            {new Date()
                                              .toISOString()
                                              .substring(0, 10)}
                                          </li>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="Modern-Header-bot"
                                    style={{
                                      display: "flex",
                                      borderTop: "1px solid #000000",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div className="Elegant-Header-bot-first">
                                      <div className="Elegant-address-rig">
                                        <h1 style={{ whiteSpace: "nowrap" }}>
                                          Billed To.
                                        </h1>
                                        {customization.customerprivacy ? (
                                          <div>
                                            <li>Customer Name</li>{" "}
                                          </div>
                                        ) : null}

                                        {customization.deliveryaddress ? (
                                          <li>
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </li>
                                        ) : null}
                                      </div>
                                    </div>
                                    {customization.deliveryaddress ? (
                                      <div className="Elegant-Header-bot-first">
                                        <div className="Elegant-address">
                                          <h1 style={{ whiteSpace: "nowrap" }}>
                                            Shipping To
                                          </h1>

                                          <li>
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </li>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <hr style={{ margin: "0px", padding: "0px" }} />
                                <div
                                  className="Classic-Body"
                                  style={{ fontSize: "12px" }}
                                >
                                  <div className="Elegant-Body-top">
                                    <table style={{ width: "100%" }}>
                                      <thead>
                                        <tr style={{ textAlign: "center" }}>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            S.no
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Items
                                          </th>

                                          {shopDetails.shopType === "Mobile" &&
                                          customization.imei1imei2 ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              IMEI1/IMEI2
                                            </th>
                                          ) : null}

                                          {customization.hsncode ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              HSN
                                            </th>
                                          ) : null}
                                          {customization.itemmrp ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              MRP
                                            </th>
                                          ) : null}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Qty
                                          </th>
                                          {customization.itemdiscount ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Disc
                                            </th>
                                          ) : null}
                                          {customization.itemleveltax ? (
                                            <th
                                              style={{ backgroundColor: color }}
                                            >
                                              Tax(%)
                                            </th>
                                          ) : null}
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Rate
                                          </th>
                                          <th
                                            style={{ backgroundColor: color }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dummy.map((value, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>{value.SNo} </td>
                                              <td style={{ textAlign: "left" }}>
                                                {customization.variant ? (
                                                  <>
                                                    {value.items}-
                                                    {value.variant}
                                                  </>
                                                ) : (
                                                  value.items
                                                )}
                                              </td>

                                              {shopDetails.shopType ===
                                                "Mobile" &&
                                              customization.imei1imei2 ? (
                                                <td>{value.IMEI}</td>
                                              ) : null}

                                              {customization.hsncode ? (
                                                <td>{value.HSN}</td>
                                              ) : null}
                                              {customization.itemmrp ? (
                                                <td>{value.MRP}</td>
                                              ) : null}
                                              <td>{value.Qty}</td>
                                              {customization.itemdiscount ? (
                                                <td>{value.Dics}</td>
                                              ) : null}
                                              {customization.itemleveltax ? (
                                                <td>{value.Tax}</td>
                                              ) : null}
                                              <td>{value.Rate}</td>
                                              <td>{value.Amount}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                  <hr
                                    style={{ border: "0.5px solid #000000" }}
                                  />
                                  <div
                                    className="Classic-Body-bot"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <div className="Classic-body-bot-left">
                                      {customization.notes && (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Notes:
                                          </div>
                                          <p
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit. liquam
                                            lacus ac elementum mi egestas dui
                                            sed lacus, pharetra.
                                          </p>
                                        </div>
                                      )}

                                      {customization.paymenyterms ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Payment Terms:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {Invoicetext.paymentTermsField}
                                          </div>
                                        </div>
                                      ) : null}
                                      {/* {customization.duedate ? (
                              <div className="Classic-body-bot-left-content">
                                <div>
                                  {" "}
                                  <strong>Due Date:</strong> 25-Aug-2021
                                </div>
                              </div>
                            ) : null} */}
                                      {/* {customization.invoiceprefix ? (
                                  <div className="Classic-body-bot-left-content">
                                    <div>
                                      {" "}
                                      <strong>Invoice Prefix:</strong>{" "}
                                      {Invoicetext.invoicePrefixtext}{" "}
                                    </div>
                                  </div>
                                ) : null} */}
                                      {customization.termscondition ? (
                                        <div className="Classic-body-bot-left-content">
                                          <div style={{ fontWeight: 600 }}>
                                            Terms and Conditions
                                          </div>
                                          <div>
                                            <li
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {Invoicetext.tAndCField}
                                            </li>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="Classic-body-bot-right">
                                      <div className="Modern-body-bot-righ-top">
                                        <div className="Elegant-body-bot-righ-top-top">
                                          <div
                                            className="Classic-body-bot-righ-top-top-title Elegant-li"
                                            style={{}}
                                          >
                                            <li>Subtotal</li>
                                            {customization.adddiscount ? (
                                              <li>Discount</li>
                                            ) : null}
                                            <li>Coupon</li>
                                            {/* <li>Taxable Amount</li>
                  <li>CGST@7%</li>
                  <li>SGST@%</li>
                  <li>Packing Chargers</li>
                  <li></li> */}
                                            {customization.othercharges ? (
                                              <li>Charges</li>
                                            ) : null}
                                            <hr
                                              style={{
                                                border: "0.5px solid #3F3F3F",
                                                marginTop: "16px",
                                              }}
                                            />
                                            <li>Total Amount</li>
                                          </div>
                                          <div
                                            className="Classic-body-bot-righ-top-top-price Elegant-li"
                                            style={{}}
                                          >
                                            <li>S200000</li>
                                            {customization.adddiscount ? (
                                              <li>7869870</li>
                                            ) : null}
                                            <li>Coupon</li>
                                            {/* <li>2387328</li>
                  <li>3238328</li>
                  <li>3238328</li>
                  <li>3238328</li>
                  <li>3238328</li> */}
                                            {customization.othercharges ? (
                                              <li>7869870</li>
                                            ) : null}
                                            <hr
                                              style={{
                                                border: "0.5px solid #3F3F3F",
                                              }}
                                            />
                                            <li style={{ color: "#EF4667" }}>
                                              3238328
                                            </li>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="Classic-body-bot-righ-mid"
                                        style={{
                                          display: "flex",
                                          marginLeft: "11px",
                                          marginRight: "-11px",
                                        }}
                                      >
                                        <div
                                          className="Classic-body-bot-righ-mid-first"
                                          style={{}}
                                        >
                                          <div>Amount Paid</div>
                                          <hr
                                            style={{
                                              border: "0.5px solid #3F3F3F",
                                              marginLeft: "78px",
                                            }}
                                          />
                                          <div>Amount Due</div>
                                        </div>
                                        <div
                                          className="Classic-body-bot-righ-mid-second"
                                          style={{}}
                                        >
                                          <div>2000000</div>
                                          <hr
                                            style={{
                                              border: "0.5px solid #3F3F3F",
                                            }}
                                          />
                                          <div>
                                            <strong>5000000</strong>
                                          </div>
                                        </div>
                                      </div>
                                      <hr
                                        style={{
                                          marginLeft: "76px",
                                          marginTop: "0px",
                                          marginBottom: "0px",
                                          bordertop: "2px solid",
                                        }}
                                      />
                                      <div className="Classic-body-bot-righ-bot">
                                        <div>
                                          <strong>Total in Words</strong>
                                        </div>
                                        <div>
                                          Two Laks Fifty Thouand Rupees only
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {customization.ghoshaklogo && (
                                  <div
                                    className="Classic-footer-A4"
                                    style={{
                                      width: "500px",
                                      marginLeft: "45px",
                                      marginTop: "0px",
                                      fontSize: "10PX",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "400",
                                        backgroundColor: color,
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <div
                                        style={{ marginLeft: "59px" }}
                                        className="Classic-footer-A4-fooert-content"
                                      >
                                        Generate professional invoice using
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-1">
                                        <img
                                          src={Logo_Original}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                          }}
                                        />
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-2">
                                        Business app
                                      </div>
                                      <div className="Classic-footer-A4-fooert-content-3">
                                        <img
                                          src={Google}
                                          style={{
                                            height: "20px",
                                            width: "60px",
                                            marginLeft: "4px",
                                            marginTop: "11px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb5">
                              {/* <button onClick={printDocument}>Print</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {Xerox.A4design === "Tabular" && (
                      <div style={{ margin: "50px 10px 10px 10px" }}>
                        <div
                          style={{
                            background: "white",
                            border: "1px solid #d4d4d4",
                            borderRadius: "16px",
                            padding: "15px",
                            fontFamily: A4Fonttype,
                          }}
                        >
                          <Row>
                            <Col span={24}>
                              <Row>
                                {/* <Col span={8} style={{ textAlign: "right" }}>
                                  {customization.shoplogo && (
                                    <div>
                                      {shopDetails.shopIconLocation !==
                                        "removed" &&
                                        " " && (
                                          <img
                                            src={shopDetails.shopIconLocation}
                                            alt="shop icon"
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              paddingLeft: "5px",
                                              borderRadius: "6px",
                                            }}
                                          />
                                        )}
                                    </div>
                                  )}
                                </Col> */}
                                <Col span={18}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {customization.shoplogo && (
                                      <div>
                                        {shopDetails.shopIconLocation !==
                                          "removed" &&
                                          " " && (
                                            <img
                                              src={shopDetails.shopIconLocation}
                                              alt="shop icon"
                                              style={{
                                                width: "100px",
                                                height: "100px",
                                                paddingLeft: "5px",
                                                borderRadius: "6px",
                                              }}
                                            />
                                          )}
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        padding: "0px 0px 0px 10px",
                                        fontSize: "22px",
                                        color: color,
                                        textAlign: "left",
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                        lineHeight: "24px",
                                      }}
                                    >
                                      {shopDetails.shopName}
                                    </div>
                                  </div>
                                </Col>
                                <Col span={6}>
                                  <div
                                    style={{
                                      fontSize: "18px",
                                      color: "black",
                                      fontWeight: "600",

                                      paddingTop: "48px",
                                    }}
                                  >
                                    TAX INVOICE
                                  </div>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  border: "1.5px solid black",
                                  marginTop: "5px",
                                  fontSize: "12px",
                                }}
                              >
                                <Col span={24}>
                                  <Row>
                                    <Col
                                      span={12}
                                      style={{
                                        borderRight: "1.5px solid black ",
                                      }}
                                    >
                                      <Row
                                        style={{
                                          borderBottom: "1.5px solid black ",
                                          padding: "5px",
                                        }}
                                      >
                                        {/* left */}
                                        <Row>
                                          <Col
                                            span={24}
                                            style={{ fontWeight: "600" }}
                                          >
                                            {shopDetails.shopName}
                                          </Col>
                                        </Row>
                                        <Col span={24}>
                                          <Row>
                                            <Col
                                              span={8}
                                              style={{ fontWeight: "600" }}
                                            >
                                              Head Office:
                                            </Col>
                                            <Col span={16}>
                                              {/* No:5 ,hkddsushuih Bhhjd
                                        fhshduisdjkbuissbb bcbxhcb -600123 */}

                                              {customization.ShopAddress && (
                                                <> {shopDetails.shopAddress}</>
                                              )}
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row style={{ padding: "5px" }}>
                                        <Col span={24}>
                                          {" "}
                                          <Row>
                                            <Col
                                              span={8}
                                              style={{ fontWeight: "600" }}
                                            >
                                              Branch Office:
                                            </Col>
                                            <Col span={16}>
                                              {/* No:5 ,hkddsushuih Bhhjd
                                        fhshduisdjkbuissbb bcbxhcb -600123 */}
                                              {customization.ShopAddress && (
                                                <> {shopDetails.shopAddress}</>
                                              )}
                                              <Row
                                                style={{
                                                  fontWeight: "600",
                                                  marginTop: "20px",
                                                }}
                                              >
                                                <Col span={8}>PHONE :</Col>
                                                <Col span={16}>
                                                  {shopDetails.shopPhoneNumber}
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col span={12}>
                                      {/* right */}
                                      <Row
                                        style={{
                                          borderBottom: "1.5px solid black ",
                                        }}
                                      >
                                        <Col
                                          span={12}
                                          style={{
                                            borderRight: "1.5px solid black ",
                                            padding: "10px",
                                          }}
                                        >
                                          <Row>
                                            <Col span={22}>Invoice No</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{
                                            padding: "10px",
                                          }}
                                        >
                                          {customization.invoicePrefixtext}
                                          {customization.invoiceSuffixtext}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          borderBottom: "1.5px solid black ",
                                        }}
                                      >
                                        <Col
                                          span={12}
                                          style={{
                                            borderRight: "1.5px solid black ",
                                            padding: "10px",
                                          }}
                                        >
                                          <Row>
                                            <Col span={22}>Invoice Date</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{
                                            padding: "10px",
                                          }}
                                        >
                                          {new Date()
                                            .toISOString()
                                            .substring(0, 10)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          borderBottom: "1.5px solid black ",
                                        }}
                                      >
                                        <Col
                                          span={12}
                                          style={{
                                            borderRight: "1.5px solid black ",
                                            padding: "10px",
                                          }}
                                        >
                                          <Row>
                                            <Col span={22}> Customer ID</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{ padding: "10px" }}
                                        ></Col>
                                      </Row>
                                      <Row>
                                        <Col
                                          span={12}
                                          style={{
                                            borderRight: "1.5px solid black ",
                                            padding: "10px",
                                          }}
                                        >
                                          <Row>
                                            <Col span={22}> Billing Period</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{ padding: "10px" }}
                                        ></Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      borderTop: "1.5px solid black",
                                      padding: "8px",
                                    }}
                                  >
                                    <Col span={12}>
                                      {customization.deliveryaddress && (
                                        <Row style={{}}>
                                          <Col span={7}>Customer Details:</Col>
                                          <Col span={17}>
                                            TAMILNADU CEMENTCORPORATION LIMITED
                                            Ariyalur cement work
                                            Ariyalur-6000123
                                          </Col>
                                        </Row>
                                      )}
                                    </Col>
                                    <Col span={12}>
                                      {customization.customerprivacy && (
                                        <Row>
                                          <Col
                                            span={12}
                                            style={{ textAlign: "center" }}
                                          >
                                            Phone No :
                                          </Col>
                                          <Col span={12}>0987655466777</Col>
                                        </Row>
                                      )}
                                      <Row>
                                        <Col
                                          span={12}
                                          style={{ textAlign: "center" }}
                                        >
                                          GSTIN No :
                                        </Col>
                                        <Col span={12}></Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <table
                                    id="invoiceTabular"
                                    style={{
                                      width: "100%",
                                      border: "1px solid black",
                                      // borderCollapse: "collapse",
                                    }}
                                  >
                                    <thead
                                      style={{
                                        border: "1px solid black",
                                      }}
                                    >
                                      <tr
                                        style={{
                                          textAlign: "center",
                                          border: "1px solid black",
                                        }}
                                      >
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "500",
                                          }}
                                        >
                                          S.no
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Items
                                        </th>

                                        {shopDetails.shopType === "Mobile" &&
                                        customization.imei1imei2 ? (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              fontWeight: "500",
                                            }}
                                          >
                                            IMEI1/IMEI2
                                          </th>
                                        ) : null}

                                        {customization.hsncode ? (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              fontWeight: "500",
                                            }}
                                          >
                                            HSN
                                          </th>
                                        ) : null}
                                        {customization.itemmrp ? (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              fontWeight: "500",
                                            }}
                                          >
                                            MRP
                                          </th>
                                        ) : null}
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Qty
                                        </th>
                                        {customization.itemdiscount ? (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              fontWeight: "500",
                                            }}
                                          >
                                            Disc
                                          </th>
                                        ) : null}
                                        {customization.itemleveltax ? (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              fontWeight: "500",
                                            }}
                                          >
                                            Tax(%)
                                          </th>
                                        ) : null}
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Rate
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody
                                      style={{
                                        border: "1px solid black",
                                      }}
                                    >
                                      {dummy.map((value, key) => {
                                        return (
                                          <tr
                                            key={key}
                                            style={{ backgroundColor: "none" }}
                                          >
                                            <td>{value.SNo} </td>
                                            <td style={{ textAlign: "left" }}>
                                              {customization.variant ? (
                                                <>
                                                  {value.items}-{value.variant}
                                                </>
                                              ) : (
                                                value.items
                                              )}
                                            </td>

                                            {shopDetails.shopType ===
                                              "Mobile" &&
                                            customization.imei1imei2 ? (
                                              <td>{value.IMEI}</td>
                                            ) : null}

                                            {customization.hsncode ? (
                                              <td>{value.HSN}</td>
                                            ) : null}
                                            {customization.itemmrp ? (
                                              <td>{value.MRP}</td>
                                            ) : null}
                                            <td>{value.Qty}</td>
                                            {customization.itemdiscount ? (
                                              <td>{value.Dics}</td>
                                            ) : null}
                                            {customization.itemleveltax ? (
                                              <td>{value.Tax}</td>
                                            ) : null}
                                            <td>{value.Rate}</td>
                                            <td>{value.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                  <div
                                    style={{
                                      width: "50%",
                                      marginLeft: "auto",
                                      padding: "10px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {/* <Row>
                                <Col span={12}>
                                  <Row>
                                    <Col span={22}>Net Amount</Col>
                                    <Col span={2}>:</Col>
                                  </Row>
                                </Col>
                                <Col span={12} style={{ textAlign: "right" }}>
                                  100000.00
                                </Col>
                              </Row> */}
                                    {/* <Row>
                                <Col span={12}>
                                  {" "}
                                  <Row>
                                    <Col span={22}>SGST</Col>
                                    <Col span={2}>:</Col>
                                  </Row>
                                </Col>
                                <Col span={12} style={{ textAlign: "right" }}>
                                  202.00
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  {" "}
                                  <Row>
                                    <Col span={22}>CGST</Col>
                                    <Col span={2}>:</Col>
                                  </Row>
                                </Col>
                                <Col span={12} style={{ textAlign: "right" }}>
                                  5476.00
                                </Col>
                              </Row> */}
                                    {customization.adddiscount && (
                                      <Row>
                                        <Col span={12}>
                                          {" "}
                                          <Row>
                                            <Col span={22}>Discount</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{ textAlign: "right" }}
                                        >
                                          1000.00
                                        </Col>
                                      </Row>
                                    )}
                                    {customization.othercharges && (
                                      <Row>
                                        <Col span={12}>
                                          {" "}
                                          <Row>
                                            <Col span={22}>Charges</Col>
                                            <Col span={2}>:</Col>
                                          </Row>
                                        </Col>
                                        <Col
                                          span={12}
                                          style={{ textAlign: "right" }}
                                        >
                                          100.00
                                        </Col>
                                      </Row>
                                    )}
                                    <Row>
                                      <Col span={12}>
                                        {" "}
                                        <Row>
                                          <Col span={22}>Subtotal</Col>
                                          <Col span={2}>:</Col>
                                        </Row>
                                      </Col>
                                      <Col
                                        span={12}
                                        style={{ textAlign: "right" }}
                                      >
                                        100000.00
                                      </Col>
                                    </Row>
                                    {/* <Row>
                                <Col span={12}>
                                  {" "}
                                  <Row>
                                    <Col span={22}>Round off</Col>
                                    <Col span={2}>:</Col>
                                  </Row>
                                </Col>
                                <Col span={12} style={{ textAlign: "right" }}>
                                  0.000
                                </Col>
                              </Row> */}
                                  </div>
                                  <div
                                    style={{
                                      padding: "10px",
                                      borderTop: "1px solid black",
                                      borderBottom: "1px solid black",
                                    }}
                                  >
                                    {" "}
                                    <Row>
                                      <Col span={12}>
                                        Rupees.Four Thousand Six Hunderd Seventy
                                        -only
                                      </Col>
                                      <Col span={12}>
                                        <Row style={{ fontWeight: "600" }}>
                                          <Col span={12}>
                                            <Row>
                                              <Col
                                                span={22}
                                                style={{ paddingLeft: "10px" }}
                                              >
                                                Total
                                              </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col
                                            span={12}
                                            style={{ textAlign: "right" }}
                                          >
                                            1000000.0
                                          </Col>
                                        </Row>
                                        <Row style={{ fontWeight: "600" }}>
                                          <Col span={12}>
                                            <Row>
                                              <Col
                                                span={22}
                                                style={{ paddingLeft: "10px" }}
                                              >
                                                Amount Paid
                                              </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col
                                            span={12}
                                            style={{ textAlign: "right" }}
                                          >
                                            10000.0
                                          </Col>
                                        </Row>
                                        <Row style={{ fontWeight: "600" }}>
                                          <Col span={12}>
                                            <Row>
                                              <Col
                                                span={22}
                                                style={{ paddingLeft: "10px" }}
                                              >
                                                Balance Amount
                                              </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col
                                            span={12}
                                            style={{ textAlign: "right" }}
                                          >
                                            100.0
                                          </Col>
                                        </Row>
                                        {/* <Row style={{ fontWeight: "600" }}>
                                    <Col span={12}>
                                      <Row>
                                        <Col
                                          span={22}
                                          style={{ paddingLeft: "10px" }}
                                        >
                                          Amount Due
                                        </Col>
                                        <Col span={2}>:</Col>
                                      </Row>
                                    </Col>
                                    <Col
                                      span={12}
                                      style={{ textAlign: "right" }}
                                    >
                                      10.0
                                    </Col>
                                  </Row> */}
                                      </Col>
                                    </Row>
                                  </div>
                                  <Row>
                                    <Col
                                      span={12}
                                      style={{
                                        borderRight: "1px solid black",
                                        padding: "10px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {shopDetails.shopGST && (
                                        <Row>
                                          <Col span={12}>
                                            <Row>
                                              <Col span={18}>GSTIN NO</Col>
                                              <Col span={6}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col span={12}>
                                            {shopDetails.shopGST}
                                          </Col>
                                        </Row>
                                      )}

                                      {/* <Row>
                                  <Col span={12}>
                                    {" "}
                                    <Row>
                                      <Col span={18}>PAN NO</Col>
                                      <Col span={6}>:</Col>
                                    </Row>
                                  </Col>
                                  <Col span={12}></Col>
                                </Row> */}
                                    </Col>
                                    {accounrDetails && (
                                      <Col
                                        span={12}
                                        style={{
                                          padding: "5px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        <div
                                          style={{
                                            textDecoration: "underline",
                                          }}
                                        >
                                          Account Details:
                                        </div>
                                        {/* <Row>
                                  <Col span={12}>
                                    <Row>
                                      <Col span={22}>BANK</Col>
                                      <Col span={2}>:</Col>
                                    </Row>
                                  </Col>
                                  <Col span={12}>CANARA BANK</Col>
                                </Row> */}

                                        <Row>
                                          <Col span={12}>
                                            <Row>
                                              <Col span={22}>A/C Name </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col span={12}>
                                            {" "}
                                            {accounrDetails.beneficiaryName}
                                          </Col>
                                        </Row>

                                        <Row>
                                          <Col span={12}>
                                            <Row>
                                              <Col span={22}>A/C NO </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>
                                          <Col span={12}>
                                            {" "}
                                            {accounrDetails.accountNumber}
                                          </Col>
                                        </Row>

                                        {/* <Row>
                                  <Col span={12}>
                                    <Row>
                                      <Col span={22}>Branch </Col>
                                      <Col span={2}>:</Col>
                                    </Row>
                                  </Col>

                                  <Col span={12}>Chennai West </Col>
                                </Row> */}

                                        <Row>
                                          <Col span={12}>
                                            <Row>
                                              <Col span={22}>IFSC </Col>
                                              <Col span={2}>:</Col>
                                            </Row>
                                          </Col>

                                          <Col span={12}>
                                            {accounrDetails.ifsc}
                                          </Col>
                                        </Row>
                                      </Col>
                                    )}
                                  </Row>
                                  <Row
                                    style={{
                                      borderTop: "1px solid black",
                                      borderRight: "1px solid black",
                                    }}
                                  >
                                    <Col
                                      span={12}
                                      style={{
                                        borderRight: "1px solid black",
                                      }}
                                    >
                                      {customization.notes && (
                                        <div style={{ padding: "5px" }}>
                                          <Row>
                                            <Col
                                              style={{ fontWeight: "600" }}
                                              span={24}
                                            >
                                              Declaration :
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col span={24}>
                                              we declare that the invoice shows
                                              the actual price of the
                                              subscription and all particulars
                                              are true and correct{" "}
                                            </Col>
                                          </Row>
                                        </div>
                                      )}
                                    </Col>
                                    <Col span={12} style={{ padding: "5px" }}>
                                      <Row style={{ paddingBottom: "32px" }}>
                                        <Col
                                          style={{
                                            marginLeft: "auto",
                                            textAlign: "center",
                                          }}
                                          span={12}
                                        >
                                          For {shopDetails.shopName}
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col
                                          style={{
                                            marginLeft: "auto",
                                            textAlign: "center",
                                          }}
                                          span={12}
                                        >
                                          Authoried Signatory
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  {customization.termscondition && (
                                    <Row
                                      style={{
                                        borderTop: "1px solid black",

                                        padding: "10px",
                                      }}
                                    >
                                      <Col
                                        span={24}
                                        style={{ fontWeight: "600" }}
                                      >
                                        Terms & Conditions :
                                      </Col>
                                      <Col
                                        span={24}
                                        style={{ marginLeft: "20px" }}
                                      >
                                        {customization.tAndCField}
                                      </Col>
                                      {/* <Col span={24} style={{ marginLeft: "20px" }}>
                                  2. Sets the kind of text decoration to use
                                  (like underline, overline, line-through)
                                </Col> */}
                                    </Row>
                                  )}
                                  <Row
                                    style={{
                                      textAlign: "center",
                                      borderTop: "1px solid black ",
                                    }}
                                  >
                                    <Col
                                      span={24}
                                      style={{
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {shopDetails.shopName}
                                    </Col>
                                    <Col span={24}>
                                      {customization.ShopAddress && (
                                        <> {shopDetails.shopAddress}</>
                                      )}
                                      {shopDetails.websiteUrl && (
                                        <div>
                                          {customization.ShopURL && (
                                            <div>
                                              {" "}
                                              {shopDetails.customDomainUrl
                                                ? shopDetails.customDomainUrl
                                                : shopDetails.websiteUrl}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                  {customization.ghoshaklogo && (
                                    <div
                                      className="Classic-footer-A4"
                                      style={{
                                        width: "500px",
                                        marginLeft: "45px",
                                        marginTop: "0px",
                                        fontSize: "10PX",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "400",
                                          backgroundColor: color,
                                          display: "flex",
                                          height: "40px",
                                        }}
                                      >
                                        <div
                                          style={{ marginLeft: "59px" }}
                                          className="Classic-footer-A4-fooert-content"
                                        >
                                          Generate professional invoice using
                                        </div>
                                        <div className="Classic-footer-A4-fooert-content-1">
                                          <img
                                            src={Logo_Original}
                                            style={{
                                              height: "20px",
                                              width: "60px",
                                            }}
                                          />
                                        </div>
                                        <div className="Classic-footer-A4-fooert-content-2">
                                          Business app
                                        </div>
                                        <div className="Classic-footer-A4-fooert-content-3">
                                          <img
                                            src={Google}
                                            style={{
                                              height: "20px",
                                              width: "60px",
                                              marginLeft: "4px",
                                              marginTop: "11px",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* cofjknf */}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="THERMAL-container4" style={{ width: "100%" }}>
                  {(Xerox.printerType === "Thermal" ||
                    Xerox.printerType === " ") && (
                    <div
                      style={{
                        border: "1px solid #D4D4D4",
                        margin: "60px",
                        backgroundColor: "#F3F3F3",
                        borderRadius: "16px",
                      }}
                    >
                      {(Xerox.thermalPapertype === "80" ||
                        Xerox.thermalPapertype === " ") && (
                        <div>
                          <div className="THERMAL-menu-left">
                            <div
                              className="THERMAL-menu-template"
                              style={{ position: "unset" }}
                            >
                              <div
                                className="Thermal-design"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  flexDirection: "column",
                                  maxWidth: "400px",
                                  fontFamily: Fonttype,
                                  textTransform: "uppercase",
                                  paddingBottom: "10px",
                                  fontWeight: 400,
                                  color: "#000",
                                  letterSpacing: "1px",
                                  fontSize: T80fontsize,
                                  margin: "69px",
                                }}
                              >
                                <div className="Thermal-header">
                                  <div className="Thermal-header-top">
                                    {/* <div>{shopDetails.shopIconLocation}</div> */}
                                    <div
                                      style={{
                                        marginTop: "4px",

                                        align: "center",
                                        fontWeight: "700",
                                        lineHeight: "15px",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {/* {customization.shoplogo ? (
                            <img
                              src={shopDetails.shopIconLocation}
                              alt="shop icon"
                              style={{
                                width: "56px",
                                height: "56px",
                                paddingLeft: "5px",
                                borderRadius: "12px",
                              }}
                            />
                          ) : null} */}
                                      {shopDetails.shopName}
                                    </div>
                                    <div
                                      style={{ margin: "0px", padding: "0px" }}
                                    >
                                      <div>
                                        <div
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          {customization.ShopAddress && (
                                            <div
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {shopDetails.shopAddress}
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          style={{
                                            margin: "0px",
                                            padding: "0px",
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: T80fontsize
                                                ? T80fontsize
                                                : "14px",
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {shopDetails.shopPhoneNumber}
                                          </div>
                                        </div>
                                      </div>
                                      {shopDetails.websiteUrl && (
                                        <div>
                                          {customization.ShopURL && (
                                            <div
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {shopDetails.customDomainUrl
                                                ? shopDetails.customDomainUrl
                                                : shopDetails.websiteUrl}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {shopDetails.shopGST && (
                                        <div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {shopDetails.shopGST}
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          textAlign: "center",
                                          fontWeight: "600",
                                        }}
                                      >
                                        CASH SALES
                                      </div>
                                    </div>
                                  </div>
                                  <div className="dash"></div>

                                  <div
                                    className=" design80 Thermal-header-bottom"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <div className="Thermal-header-bottom-left">
                                      <div
                                        style={{
                                          margin: "0px",
                                          padding: "0px",
                                          // textAlign: "center",
                                        }}
                                      >
                                        <div>
                                          <div
                                            style={{
                                              fontWeight: "500",
                                              overflowWrap: "break-word",
                                              textAlign: "left",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Invoice No:
                                            {Invoicetext.invoicePrefixtext}
                                            {Invoicetext.currentInvoiceNumber}
                                          </div>
                                        </div>

                                        <div>
                                          {customization.customerprivacy && (
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                overflowWrap: "break-word",
                                                textAlign: "left",
                                              }}
                                            >
                                              Name:GHOSHAK
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="Thermal-header-bottom-right"
                                      style={{ wordBreak: "break-word" }}
                                    >
                                      <div>
                                        <div>
                                          <div
                                            style={{
                                              fontWeight: "500",
                                              overflowWrap: "break-word",
                                              textAlign: "right",
                                            }}
                                          >
                                            Date:{currentDate}
                                          </div>
                                        </div>

                                        <div>
                                          {customization.customerprivacy && (
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                overflowWrap: "break-word",
                                                textAlign: "right",
                                              }}
                                            >
                                              Mobile:9876543211
                                            </div>
                                          )}
                                          {shopDetails.employeeName && (
                                            <div
                                              style={{
                                                overflowWrap: "break-word",
                                                textAlign: "right",
                                              }}
                                            >
                                              Billed By:GHOSHAK
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="dash"
                                    style={{ margin: "4px 0" }}
                                  ></div>
                                </div>
                                <div
                                  className="Thermal-Body"
                                  style={{
                                    fontSize: T80fontsize
                                      ? T80fontsize
                                      : "14px",
                                  }}
                                >
                                  <div
                                    className="Thermal-body-first"
                                    style={{ fontWeight: 500 }}
                                  >
                                    <div className="holder" style={{}}>
                                      <div>
                                        {/* <div className="item"  style={{width:'350px',textAlign:"left" }}>ITEM Name</div> */}
                                      </div>
                                      <div>
                                        <div
                                          className="item1"
                                          style={{
                                            textAlign: "left",
                                            width: "115px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          ITEM NAME
                                        </div>
                                      </div>
                                      <div
                                        className="item1"
                                        style={{ fontWeight: 600 }}
                                      >
                                        QTY
                                      </div>
                                      <div
                                        className="item1"
                                        style={{ fontWeight: 600 }}
                                      >
                                        RATE
                                      </div>
                                      {customization.itemmrp ? (
                                        <div
                                          className="item1"
                                          style={{ fontWeight: 600 }}
                                        >
                                          MRP
                                        </div>
                                      ) : null}
                                      {customization.itemdiscount ? (
                                        <div
                                          className="item1"
                                          style={{ fontWeight: 600 }}
                                        >
                                          DISC
                                        </div>
                                      ) : null}
                                      {customization.hsncode ? (
                                        <div
                                          className="item1"
                                          style={{ fontWeight: 600 }}
                                        >
                                          HSN
                                        </div>
                                      ) : null}
                                      {customization.itemleveltax ? (
                                        <div
                                          className="item1"
                                          style={{ fontWeight: 600 }}
                                        >
                                          TAX(%)
                                        </div>
                                      ) : null}

                                      {shopDetails.shopType === "Mobile" &&
                                      customization.imei1imei2 ? (
                                        <div
                                          className="item1"
                                          style={{ fontWeight: 600 }}
                                        >
                                          IMEI
                                        </div>
                                      ) : null}
                                      <div
                                        className="item1"
                                        style={{
                                          textAlign: "right",
                                          marginLeft: "auto",
                                          fontWeight: 600,
                                        }}
                                      >
                                        AMOUNT
                                      </div>
                                    </div>
                                    <div
                                      className="dash"
                                      style={{ margin: "4px 0" }}
                                    ></div>

                                    <>
                                      <div style={{ fontWeight: "500" }}>
                                        <div className="holder">
                                          <div
                                            className="item1"
                                            style={{
                                              width: "115px",
                                              textAlign: "left",
                                              overflowWrap: "break-word",
                                              wordBreak: "break-all",
                                              lineHeight: "15px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {" "}
                                            Item Name
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                            className="item1"
                                          >
                                            1
                                          </div>
                                          <div
                                            className="item1"
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            1000
                                          </div>
                                          {customization.itemmrp ? (
                                            <div
                                              style={{
                                                overflowWrap: "break-word",

                                                textAlign: "center",
                                              }}
                                              className="item1"
                                            >
                                              1100
                                            </div>
                                          ) : null}
                                          {customization.itemdiscount ? (
                                            <div
                                              className="item1"
                                              style={{
                                                overflowWrap: "break-word",

                                                textAlign: "center",
                                              }}
                                            >
                                              1000
                                            </div>
                                          ) : null}
                                          {customization.hsncode ? (
                                            <div
                                              className="item1"
                                              style={{
                                                overflowWrap: "break-word",

                                                textAlign: "center",
                                              }}
                                            >
                                              09876
                                            </div>
                                          ) : null}
                                          {customization.itemleveltax ? (
                                            <div
                                              className="item1"
                                              style={{
                                                overflowWrap: "break-word",

                                                textAlign: "center",
                                              }}
                                            >
                                              TAX(%)
                                            </div>
                                          ) : null}
                                          {shopDetails.shopType ===
                                            "Mobile" && (
                                            <div>
                                              {" "}
                                              {customization.imei1imei2 ? (
                                                <div
                                                  className="item1"
                                                  style={{
                                                    overflowWrap: "break-word",

                                                    textAlign: "center",
                                                  }}
                                                >
                                                  12345
                                                </div>
                                              ) : null}
                                            </div>
                                          )}
                                          <div
                                            className="item1"
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "right",
                                              marginLeft: "auto",
                                            }}
                                          >
                                            1000
                                          </div>
                                        </div>
                                        {/* <div
                                  className="dash"
                                  style={{
                                    margin: "2px 0",
                                  }}
                                /> */}
                                      </div>
                                    </>
                                  </div>
                                  <div
                                    className="dash"
                                    style={{
                                      margin: "4px 0",
                                    }}
                                  />

                                  <div
                                    className="Thermal-body-second"
                                    style={{
                                      fontWeight: 500,
                                      marginTop: "-4px",
                                    }}
                                  >
                                    <div>
                                      <Row>
                                        <Col span={17} className="columnData">
                                          Sub Total
                                        </Col>
                                        <Col
                                          span={7}
                                          className="columnData1"
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          {currencyFormatter(1000)}
                                        </Col>
                                      </Row>

                                      {customization.adddiscount && (
                                        <Row>
                                          <Col span={17} className="columnData">
                                            Discount(Flat)
                                          </Col>
                                          <Col
                                            span={7}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {currencyFormatter(10)}
                                          </Col>
                                        </Row>
                                      )}

                                      <Row>
                                        <Col span={17} className="columnData">
                                          Coupon Code
                                        </Col>
                                        <Col
                                          span={7}
                                          className="columnData1"
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          10
                                        </Col>
                                      </Row>

                                      {customization.othercharges && (
                                        <Row>
                                          <Col span={17} className="columnData">
                                            Charges :
                                          </Col>
                                          <Col
                                            span={7}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {currencyFormatter(10)}
                                          </Col>
                                        </Row>
                                      )}

                                      {customization.customerprivacy && (
                                        <div>
                                          <Row>
                                            <Col
                                              span={17}
                                              className="columnData"
                                            >
                                              Loyalty Discount(Points)
                                            </Col>
                                            <Col
                                              span={7}
                                              className="columnData1"
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              50.10
                                            </Col>
                                          </Row>
                                        </div>
                                      )}

                                      <Row>
                                        <Col span={17} className="columnData">
                                          Total Amount
                                        </Col>
                                        <Col
                                          span={7}
                                          className="columnData1"
                                          style={{
                                            overflowWrap: "break-word",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {currencyFormatter(1000)}
                                        </Col>
                                      </Row>
                                    </div>

                                    {/* <div className="dash"></div> */}

                                    <div
                                      className="Thermal-body-details"
                                      style={{
                                        // display: "flex",
                                        marginTop: "5px",
                                        gap: "5px",
                                      }}
                                    >
                                      <Row style={{ textAlign: "left" }}>
                                        <Col
                                          span={16}
                                          style={{ textAlign: "left" }}
                                        >
                                          Total Item count
                                        </Col>
                                        <Col
                                          span={8}
                                          className="columnData1"
                                          style={{
                                            overflowWrap: "break-word",
                                            textAlign: "left",
                                          }}
                                        >
                                          {1}
                                        </Col>
                                      </Row>
                                      <strong>
                                        <div>Total(In Words)</div>
                                      </strong>
                                      <div
                                        style={{ overflowWrap: "break-word" }}
                                      >
                                        One Thousand Only
                                      </div>
                                    </div>
                                    {/* <div className="dash"></div> */}

                                    <div
                                      style={{
                                        // display: "flex",
                                        gap: "4px",
                                        padding: "4px",
                                      }}
                                    >
                                      <div>
                                        <Row>
                                          <Col span={24}>
                                            {" "}
                                            {customization.customerprivacy && (
                                              <div
                                                style={{
                                                  // display: "flex",
                                                  // flexDirection: "row",
                                                  // width: "50%",
                                                  fontWeight: "900",
                                                }}
                                              >
                                                <Row>
                                                  <Col
                                                    span={12}
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    Loyalty Pts:
                                                  </Col>
                                                  <Col
                                                    span={12}
                                                    style={{
                                                      overflowWrap:
                                                        "break-word",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    100
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}{" "}
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col span={24}>
                                            {customization.itemmrp && (
                                              <div>
                                                <div className="dash"></div>
                                                <div
                                                  style={{
                                                    // display: "flex",
                                                    // flexDirection: "row",
                                                    // width: "50%",
                                                    fontWeight: "900",
                                                    // fontSize: "1.5rem",
                                                  }}
                                                >
                                                  <Row
                                                    style={{ fontSize: "24px" }}
                                                  >
                                                    <Col
                                                      span={16}
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Saved Amount:
                                                    </Col>
                                                    <Col
                                                      span={8}
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {" "}
                                                      {currencyFormatter(100)}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </div>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>

                                    {/* <div className="dash"></div> */}

                                    <div className="dash"></div>
                                    <div
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      <Row>
                                        <Col
                                          span={14}
                                          style={{
                                            overflowWrap: "break-word",
                                            textAlign: "left",
                                            fontWeight: "600",
                                          }}
                                        >
                                          Paid:
                                        </Col>
                                        <Col
                                          span={10}
                                          style={{
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {currencyFormatter(1100)}
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col
                                          span={17}
                                          style={{
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                            fontWeight: "600",
                                          }}
                                        >
                                          Balance Amount:
                                        </Col>
                                        <Col
                                          span={7}
                                          style={{
                                            overflowWrap: "break-word",
                                            textAlign: "right",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {currencyFormatter(100)}
                                        </Col>
                                      </Row>

                                      {/* {billInput.billAmountDue > 0 && (
                                  <Row>
                                    <Col
                                      span={18}
                                      style={{
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Pending Amount:
                                    </Col>
                                    <Col
                                      span={6}
                                      style={{
                                        overflowWrap: "break-word",
                                        textAlign: "right",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {" "}
                                      
                                      {currencyFormatter(
                                        Math.abs(billInput.billAmountDue)
                                      )}
                                    </Col>
                                  </Row>
                                )} */}
                                    </div>
                                  </div>

                                  {customization.itemleveltax && (
                                    <>
                                      {customization.itemleveltax && (
                                        <div>
                                          <div
                                            className="dash"
                                            style={{ margin: "2px 0" }}
                                          ></div>
                                          <div class="table-row header">
                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              Desc
                                            </div>
                                            <div
                                              style={{
                                                textAlign: "left",
                                                width: "96px",
                                              }}
                                              className="taxable"
                                            >
                                              Taxable
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              CGST
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              SGST
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              CESS
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              Igst
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                              className="num-80"
                                            >
                                              Add.CESS
                                            </div>
                                          </div>

                                          <div className="table-row">
                                            <div
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                              className="num-80"
                                            >
                                              2%
                                            </div>
                                            <div
                                              className="taxable"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                                width: "96px",
                                              }}
                                            >
                                              2
                                            </div>

                                            <div
                                              className="num-80"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                            >
                                              3
                                            </div>

                                            <div
                                              className="num-80"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                            >
                                              1
                                            </div>

                                            <div
                                              className="num-80"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                            >
                                              2
                                            </div>

                                            <div
                                              className="num-80"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                            >
                                              6
                                            </div>

                                            <div
                                              className="num-80"
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "500",
                                              }}
                                            >
                                              10
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  <div className="dash"></div>
                                </div>

                                <div className="Thermal-Footer">
                                  {customization.deliveryaddress ? (
                                    <div>
                                      <div>
                                        <strong>
                                          <div style={{ fontWeight: "600" }}>
                                            Address:
                                          </div>
                                        </strong>

                                        <div
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          No:16,BV 2nd street, Thiruvanmiyur,
                                          Chennai - 600011.
                                        </div>
                                        <div className="dash"></div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {customization.termscondition ? (
                                    <div>
                                      <div>
                                        <div style={{ fontWeight: "500" }}>
                                          Terms and Condition:
                                        </div>
                                        <div
                                          style={{
                                            overflowWrap: "break-word",
                                            fontWeight: "lighter",
                                          }}
                                        >
                                          {customization.tAndCField}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {customization.paymenyterms ? (
                                    <div>
                                      <div>
                                        <div style={{ fontWeight: "500" }}>
                                          Payment terms:
                                        </div>
                                        <div
                                          style={{
                                            overflowWrap: "break-word",
                                            fontWeight: "lighter",
                                          }}
                                        >
                                          {customization.paymentTermsField}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  {/* {customization.invoiceprefix ? (
                              <div>
                                <div style={{ display: "flex" }}>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    Invoice-Prefix:
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "lighter",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {customization.invoicePrefixtext}
                                  </div>
                                </div>
                              </div>
                            ) : null} */}
                                  {customization.notes && (
                                    <div style={{ display: "flex" }}>
                                      <div
                                        style={{ overflowWrap: "break-word" }}
                                      >
                                        Notes:{" "}
                                        <div
                                          style={{
                                            fontWeight: "lighter",
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          We're here to serve only the best
                                          products for you.
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      textAlign: "center",

                                      fontWeight: "400",
                                      letterSpacing: "0.05",
                                      color: "#000000",
                                      margin: "0px",
                                    }}
                                  >
                                    *****Thanks you for shopping!!!*****
                                  </div>
                                  <div>
                                    {customization.QRCode && (
                                      <div
                                        style={{
                                          textAlign: "center",
                                          margin: "0px",
                                        }}
                                      >
                                        {shopDetails.customDomainUrl ? (
                                          <QRCode
                                            value={shopDetails.customDomainUrl}
                                            size={60}
                                          />
                                        ) : (
                                          <QRCode
                                            value={
                                              "https://play.google.com/store/apps/details?id=com.ghoshak_owner"
                                            }
                                            size={80}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {Xerox.thermalPapertype === "55" && (
                        <div>
                          <div className="THERMAL-menu-left">
                            <div
                              className="THERMAL-menu-template"
                              style={{ position: "unset" }}
                            >
                              <div
                                className="Thermal2mm-design Thermal-design"
                                style={{
                                  fontSize: 10,
                                  width: "270px",
                                  marginLeft: "113px",

                                  marginTop: "30px",
                                  marginBottom: "40px",
                                }}
                              >
                                <div
                                  className="root"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexDirection: "column",
                                    maxWidth: "270px",
                                    fontFamily: Fonttype,
                                    textTransform: "uppercase",
                                    paddingBottom: "10px",
                                    fontWeight: 400,
                                    color: "#000",
                                    letterSpacing: "0.5px",
                                    fontSize: T55fontsize,
                                  }}
                                >
                                  <div className="Thermal-header">
                                    <div className="Thermal-header-top">
                                      {/* <div>{shopDetails.shopIconLocation}</div> */}
                                      <div
                                        style={{
                                          marginTop: "4px",

                                          align: "center",
                                          fontWeight: "700",
                                          lineHeight: "15px",
                                          overflowWrap: "break-word",
                                        }}
                                      >
                                        {/* {customization.shoplogo ? (
                            <img
                              src={shopDetails.shopIconLocation}
                              alt="shop icon"
                              style={{
                                width: "56px",
                                height: "56px",
                                paddingLeft: "5px",
                                borderRadius: "12px",
                              }}
                            />
                          ) : null} */}
                                        {shopDetails.shopName}
                                      </div>
                                      <div
                                        style={{
                                          margin: "0px",
                                          padding: "0px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {customization.ShopAddress && (
                                              <div
                                                style={{
                                                  overflowWrap: "break-word",
                                                }}
                                              >
                                                {shopDetails.shopAddress}
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            style={{
                                              margin: "0px",
                                              padding: "0px",
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: T55fontsize
                                                  ? T55fontsize
                                                  : "14px",
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {shopDetails.shopPhoneNumber}
                                            </div>
                                          </div>
                                        </div>
                                        {shopDetails.websiteUrl && (
                                          <div>
                                            {customization.ShopURL && (
                                              <div
                                                style={{
                                                  overflowWrap: "break-word",
                                                }}
                                              >
                                                {shopDetails.customDomainUrl
                                                  ? shopDetails.customDomainUrl
                                                  : shopDetails.websiteUrl}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        {shopDetails.shopGST && (
                                          <div>
                                            <div
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {shopDetails.shopGST}
                                            </div>
                                          </div>
                                        )}
                                        <div
                                          style={{
                                            textAlign: "center",
                                            fontWeight: "600",
                                          }}
                                        >
                                          CASH SALES
                                        </div>
                                      </div>
                                    </div>
                                    <div className="dash"></div>

                                    <div
                                      className=" design80 Thermal-header-bottom"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <div className="Thermal-header-bottom-left">
                                        <div
                                          style={{
                                            margin: "0px",
                                            padding: "0px",
                                            // textAlign: "center",
                                          }}
                                        >
                                          <div>
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                overflowWrap: "break-word",
                                                textAlign: "left",
                                              }}
                                            >
                                              Invoice No:
                                              {Invoicetext.invoicePrefixtext}
                                              {Invoicetext.currentInvoiceNumber}
                                            </div>
                                          </div>

                                          <div>
                                            {customization.customerprivacy && (
                                              <div
                                                style={{
                                                  fontWeight: "500",
                                                  overflowWrap: "break-word",
                                                  textAlign: "left",
                                                }}
                                              >
                                                Name:GHOSHAK
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="Thermal-header-bottom-right"
                                        style={{ wordBreak: "break-word" }}
                                      >
                                        <div>
                                          <div>
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                overflowWrap: "break-word",
                                                textAlign: "right",
                                              }}
                                            >
                                              Date:{currentDate}
                                            </div>
                                          </div>

                                          <div>
                                            {customization.customerprivacy && (
                                              <div
                                                style={{
                                                  fontWeight: "500",
                                                  overflowWrap: "break-word",
                                                  textAlign: "right",
                                                }}
                                              >
                                                Mobile:9876543211
                                              </div>
                                            )}
                                            {shopDetails.employeeName && (
                                              <div
                                                style={{
                                                  overflowWrap: "break-word",
                                                  textAlign: "right",
                                                }}
                                              >
                                                Billed By:GHOSHAK
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="dash"
                                      style={{ margin: "4px 0" }}
                                    ></div>
                                  </div>
                                  <div
                                    className="Thermal-Body"
                                    style={{
                                      fontSize: T55fontsize
                                        ? T55fontsize
                                        : "14px",
                                    }}
                                  >
                                    <div
                                      className="Thermal-body-first"
                                      style={{ fontWeight: 500 }}
                                    >
                                      <div className="holder" style={{}}>
                                        <div>
                                          {/* <div className="item"  style={{width:'350px',textAlign:"left" }}>ITEM Name</div> */}
                                        </div>
                                        <div>
                                          <div
                                            className="item1"
                                            style={{
                                              textAlign: "left",
                                              width: "63px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            ITEM
                                          </div>
                                        </div>
                                        <div
                                          className="item1"
                                          style={{
                                            fontWeight: 600,
                                            width: "63px",
                                          }}
                                        >
                                          QTY
                                        </div>
                                        <div
                                          className="item1"
                                          style={{
                                            fontWeight: 600,
                                            width: "63px",
                                          }}
                                        >
                                          RATE
                                        </div>
                                        {customization.itemmrp ? (
                                          <div
                                            className="item1"
                                            style={{
                                              fontWeight: 600,
                                              width: "63px",
                                            }}
                                          >
                                            MRP
                                          </div>
                                        ) : null}
                                        {customization.itemdiscount ? (
                                          <div
                                            className="item1"
                                            style={{
                                              fontWeight: 600,
                                              width: "63px",
                                            }}
                                          >
                                            DISC
                                          </div>
                                        ) : null}
                                        {customization.hsncode ? (
                                          <div
                                            className="item1"
                                            style={{
                                              fontWeight: 600,
                                              width: "63px",
                                            }}
                                          >
                                            HSN
                                          </div>
                                        ) : null}
                                        {customization.itemleveltax ? (
                                          <div
                                            className="item1"
                                            style={{
                                              fontWeight: 600,
                                              width: "63px",
                                            }}
                                          >
                                            TAX(%)
                                          </div>
                                        ) : null}

                                        {shopDetails.shopType === "Mobile" &&
                                        customization.imei1imei2 ? (
                                          <div
                                            className="item1"
                                            style={{
                                              fontWeight: 600,
                                              width: "63px",
                                            }}
                                          >
                                            IMEI
                                          </div>
                                        ) : null}
                                        <div
                                          className="item1"
                                          style={{
                                            textAlign: "right",
                                            marginLeft: "auto",
                                            fontWeight: 600,
                                            width: "63px",
                                          }}
                                        >
                                          AMOUNT
                                        </div>
                                      </div>
                                      <div
                                        className="dash"
                                        style={{ margin: "4px 0" }}
                                      ></div>

                                      <>
                                        <div style={{ fontWeight: "500" }}>
                                          <div className="holder">
                                            <div
                                              className="item1"
                                              style={{
                                                width: "63px",
                                                textAlign: "left",
                                                overflowWrap: "break-word",
                                                wordBreak: "break-all",
                                                lineHeight: "15px",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {" "}
                                              Item
                                            </div>
                                            <div
                                              style={{
                                                overflowWrap: "break-word",
                                                width: "63px",
                                              }}
                                              className="item1"
                                            >
                                              1
                                            </div>
                                            <div
                                              className="item1"
                                              style={{
                                                overflowWrap: "break-word",
                                                width: "63px",
                                              }}
                                            >
                                              1000
                                            </div>
                                            {customization.itemmrp ? (
                                              <div
                                                style={{
                                                  overflowWrap: "break-word",

                                                  textAlign: "center",
                                                  width: "63px",
                                                }}
                                                className="item1"
                                              >
                                                1100
                                              </div>
                                            ) : null}
                                            {customization.itemdiscount ? (
                                              <div
                                                className="item1"
                                                style={{
                                                  overflowWrap: "break-word",

                                                  textAlign: "center",
                                                  width: "63px",
                                                }}
                                              >
                                                1000
                                              </div>
                                            ) : null}
                                            {customization.hsncode ? (
                                              <div
                                                className="item1"
                                                style={{
                                                  overflowWrap: "break-word",

                                                  textAlign: "center",
                                                  width: "63px",
                                                }}
                                              >
                                                09876
                                              </div>
                                            ) : null}
                                            {customization.itemleveltax ? (
                                              <div
                                                className="item1"
                                                style={{
                                                  overflowWrap: "break-word",

                                                  textAlign: "center",
                                                  width: "63px",
                                                }}
                                              >
                                                TAX(%)
                                              </div>
                                            ) : null}
                                            {shopDetails.shopType ===
                                              "Mobile" && (
                                              <div>
                                                {" "}
                                                {customization.imei1imei2 ? (
                                                  <div
                                                    className="item1"
                                                    style={{
                                                      overflowWrap:
                                                        "break-word",

                                                      textAlign: "center",
                                                      width: "63px",
                                                    }}
                                                  >
                                                    12345
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                            <div
                                              className="item1"
                                              style={{
                                                overflowWrap: "break-word",
                                                textAlign: "right",
                                                marginLeft: "auto",
                                                width: "63px",
                                              }}
                                            >
                                              1000
                                            </div>
                                          </div>
                                          {/* <div
                                  className="dash"
                                  style={{
                                    margin: "2px 0",
                                  }}
                                /> */}
                                        </div>
                                      </>
                                    </div>
                                    <div
                                      className="dash"
                                      style={{
                                        margin: "4px 0",
                                      }}
                                    />

                                    <div
                                      className="Thermal-body-second"
                                      style={{
                                        fontWeight: 500,
                                        marginTop: "-4px",
                                      }}
                                    >
                                      <div>
                                        <Row>
                                          <Col span={17} className="columnData">
                                            Sub Total
                                          </Col>
                                          <Col
                                            span={7}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            {currencyFormatter(1000)}
                                          </Col>
                                        </Row>

                                        {customization.adddiscount && (
                                          <Row>
                                            <Col
                                              span={17}
                                              className="columnData"
                                            >
                                              Discount(Flat)
                                            </Col>
                                            <Col
                                              span={7}
                                              className="columnData1"
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {currencyFormatter(10)}
                                            </Col>
                                          </Row>
                                        )}

                                        <Row>
                                          <Col span={17} className="columnData">
                                            Coupon Code
                                          </Col>
                                          <Col
                                            span={7}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            10
                                          </Col>
                                        </Row>

                                        {customization.othercharges && (
                                          <Row>
                                            <Col
                                              span={17}
                                              className="columnData"
                                            >
                                              Charges :
                                            </Col>
                                            <Col
                                              span={7}
                                              className="columnData1"
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {currencyFormatter(10)}
                                            </Col>
                                          </Row>
                                        )}

                                        {customization.customerprivacy && (
                                          <div>
                                            <Row>
                                              <Col
                                                span={17}
                                                className="columnData"
                                              >
                                                Loyalty Discount(Points)
                                              </Col>
                                              <Col
                                                span={7}
                                                className="columnData1"
                                                style={{
                                                  overflowWrap: "break-word",
                                                }}
                                              >
                                                50.10
                                              </Col>
                                            </Row>
                                          </div>
                                        )}

                                        <Row>
                                          <Col span={17} className="columnData">
                                            Total Amount
                                          </Col>
                                          <Col
                                            span={7}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {currencyFormatter(1000)}
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* <div className="dash"></div> */}

                                      <div
                                        className="Thermal-body-details"
                                        style={{
                                          // display: "flex",
                                          marginTop: "5px",
                                          gap: "5px",
                                        }}
                                      >
                                        <Row style={{ textAlign: "left" }}>
                                          <Col
                                            span={16}
                                            style={{ textAlign: "left" }}
                                          >
                                            Total Item count
                                          </Col>
                                          <Col
                                            span={8}
                                            className="columnData1"
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "left",
                                            }}
                                          >
                                            {1}
                                          </Col>
                                        </Row>
                                        <strong>
                                          <div>Total(In Words)</div>
                                        </strong>
                                        <div
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          One Thousand Only
                                        </div>
                                      </div>
                                      {/* <div className="dash"></div> */}

                                      <div
                                        style={{
                                          // display: "flex",
                                          gap: "4px",
                                          padding: "4px",
                                        }}
                                      >
                                        <div>
                                          <Row>
                                            <Col span={24}>
                                              {" "}
                                              {customization.customerprivacy && (
                                                <div
                                                  style={{
                                                    // display: "flex",
                                                    // flexDirection: "row",
                                                    // width: "50%",
                                                    fontWeight: "900",
                                                  }}
                                                >
                                                  <Row>
                                                    <Col
                                                      span={12}
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Loyalty Pts:
                                                    </Col>
                                                    <Col
                                                      span={12}
                                                      style={{
                                                        overflowWrap:
                                                          "break-word",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      100
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}{" "}
                                            </Col>
                                          </Row>
                                        </div>
                                        <div>
                                          <Row>
                                            <Col span={24}>
                                              {customization.itemmrp && (
                                                <div>
                                                  <div className="dash"></div>
                                                  <div
                                                    style={{
                                                      // display: "flex",
                                                      // flexDirection: "row",
                                                      // width: "50%",
                                                      fontWeight: "900",
                                                      fontSize: "16px",
                                                    }}
                                                  >
                                                    <Row>
                                                      <Col
                                                        span={16}
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Saved Amount:
                                                      </Col>
                                                      <Col
                                                        span={8}
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {currencyFormatter(10)}
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>

                                      {/* <div className="dash"></div> */}

                                      <div className="dash"></div>
                                      <div
                                        style={{
                                          display: "flex",
                                        }}
                                      >
                                        <Row>
                                          <Col
                                            span={14}
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "left",
                                              fontWeight: "600",
                                            }}
                                          >
                                            Paid:
                                          </Col>
                                          <Col
                                            span={10}
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "center",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {currencyFormatter(1100)}
                                          </Col>
                                        </Row>

                                        <Row>
                                          <Col
                                            span={15}
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "center",
                                              fontWeight: "600",
                                            }}
                                          >
                                            Balance Amount:
                                          </Col>
                                          <Col
                                            span={9}
                                            style={{
                                              overflowWrap: "break-word",
                                              textAlign: "right",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {currencyFormatter(100)}
                                          </Col>
                                        </Row>

                                        {/* {billInput.billAmountDue > 0 && (
                                  <Row>
                                    <Col
                                      span={18}
                                      style={{
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Pending Amount:
                                    </Col>
                                    <Col
                                      span={6}
                                      style={{
                                        overflowWrap: "break-word",
                                        textAlign: "right",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {" "}
                                      
                                      {currencyFormatter(
                                        Math.abs(billInput.billAmountDue)
                                      )}
                                    </Col>
                                  </Row>
                                )} */}
                                      </div>
                                    </div>

                                    {customization.itemleveltax && (
                                      <>
                                        {customization.itemleveltax && (
                                          <div>
                                            <div
                                              className="dash"
                                              style={{ margin: "2px 0" }}
                                            ></div>
                                            <div class="table-row header">
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  width: "64px",
                                                }}
                                                className="num-80"
                                              >
                                                Desc
                                              </div>
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  width: "73px",
                                                }}
                                                className="taxable"
                                              >
                                                Taxable
                                              </div>

                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  width: "66px",
                                                }}
                                                className="num-80"
                                              >
                                                CGST
                                              </div>

                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  width: "64px",
                                                }}
                                                className="num-80"
                                              >
                                                SGST
                                              </div>

                                              <div
                                                style={{
                                                  textAlign: "left",
                                                }}
                                                className="num-80"
                                              >
                                                CESS
                                              </div>

                                              <div
                                                style={{
                                                  textAlign: "left",
                                                }}
                                                className="num-80"
                                              >
                                                Igst
                                              </div>

                                              <div
                                                style={{
                                                  textAlign: "left",
                                                }}
                                                className="num-80"
                                              >
                                                Add.CESS
                                              </div>
                                            </div>

                                            <div className="table-row">
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                  width: "65px",
                                                }}
                                                className="num-80"
                                              >
                                                2%
                                              </div>
                                              <div
                                                className="taxable"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                  width: "73px",
                                                }}
                                              >
                                                2
                                              </div>

                                              <div
                                                className="num-80"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                  width: "66px",
                                                }}
                                              >
                                                3
                                              </div>

                                              <div
                                                className="num-80"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                  width: "64px",
                                                }}
                                              >
                                                1
                                              </div>

                                              <div
                                                className="num-80"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                2
                                              </div>

                                              <div
                                                className="num-80"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                6
                                              </div>

                                              <div
                                                className="num-80"
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                10
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    )}
                                    <div className="dash"></div>
                                  </div>

                                  <div className="Thermal-Footer">
                                    {customization.deliveryaddress ? (
                                      <div>
                                        <div>
                                          <strong>
                                            <div style={{ fontWeight: "600" }}>
                                              Address:
                                            </div>
                                          </strong>

                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            No:16,BV 2nd street, Thiruvanmiyur,
                                            Chennai - 600011.
                                          </div>
                                          <div className="dash"></div>
                                        </div>
                                      </div>
                                    ) : null}
                                    {customization.termscondition ? (
                                      <div>
                                        <div>
                                          <div style={{ fontWeight: "500" }}>
                                            Terms and Condition:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                              fontWeight: "lighter",
                                            }}
                                          >
                                            {customization.tAndCField}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    {customization.paymenyterms ? (
                                      <div>
                                        <div>
                                          <div style={{ fontWeight: "500" }}>
                                            Payment terms:
                                          </div>
                                          <div
                                            style={{
                                              overflowWrap: "break-word",
                                              fontWeight: "lighter",
                                            }}
                                          >
                                            {customization.paymentTermsField}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}

                                    {/* {customization.invoiceprefix ? (
                                <div>
                                  <div style={{ display: "flex" }}>
                                    <div style={{ overflowWrap: "break-word" }}>
                                      Invoice-Prefix:
                                    </div>
                                    <div
                                      style={{
                                        fontWeight: "lighter",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {customization.invoicePrefixtext}
                                    </div>
                                  </div>
                                </div>
                              ) : null} */}
                                    {customization.notes && (
                                      <div style={{ display: "flex" }}>
                                        <div
                                          style={{ overflowWrap: "break-word" }}
                                        >
                                          Notes:{" "}
                                          <div
                                            style={{
                                              fontWeight: "lighter",
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            We're here to serve only the best
                                            products for you.
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        textAlign: "center",

                                        fontWeight: "400",
                                        letterSpacing: "0.05",
                                        color: "#000000",
                                        margin: "0px",
                                      }}
                                    >
                                      *****Thanks you for shopping!!!*****
                                    </div>
                                    <div>
                                      {customization.QRCode && (
                                        <div
                                          style={{
                                            textAlign: "center",
                                            margin: "0px",
                                          }}
                                        >
                                          {shopDetails.customDomainUrl ? (
                                            <QRCode
                                              value={
                                                shopDetails.customDomainUrl
                                              }
                                              size={60}
                                            />
                                          ) : (
                                            <QRCode
                                              value={
                                                "https://play.google.com/store/apps/details?id=com.ghoshak_owner"
                                              }
                                              size={80}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Menu tab ----------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
              <div style={{ width: "40%" }}>
                <div className="THERMAL-right-right">
                  <form>
                    {/* // onChange="setTimeout(handleClick, 3000)"> */}
                    <div style={{}}>
                      <button
                        onClick={(e) => {
                          handleClick(e);
                        }}
                        ref={callback}
                        style={{
                          display: "none",
                          backgroundColor: "#67748E",
                          borderRadius: "4px",
                          float: "right",
                          margin: "16px",
                        }}
                      ></button>
                    </div>
                    <div className="THERMAL-right-head">
                      <div
                        style={{ display: "flex" }}
                        onClick={() => setHshow(!hshow)}
                      >
                        <div style={{ fontSize: "20px", padding: "5px" }}>
                          Header
                        </div>
                        <div style={{ marginLeft: "auto" }}>
                          {hshow ? (
                            <i class="arrow down"></i>
                          ) : (
                            <i class="arrow up"></i>
                          )}
                        </div>
                      </div>

                      <hr />
                      {hshow ? (
                        <>
                          <div>
                            <Checkbox
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              checked={customization.customerprivacy}
                              name="customerprivacy"
                            >
                              Customer Name & Mobile.
                            </Checkbox>
                            <div className="checkbox-design">
                              Display Customer name and mobile number.
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              checked={customization.ShopURL}
                              name="ShopURL"
                            >
                              Shop URL
                            </Checkbox>
                            <div className="checkbox-design">
                              Display Shop URL.
                            </div>
                          </div>
                          {Xerox.printerType === "A4" && (
                            <div>
                              <Checkbox
                                onClick={(e) => {
                                  if (!access.otherAccess(false)) {
                                    return alert(
                                      "You don't have access, Please contact your administrator to request the appropriate access."
                                    );
                                  }
                                  updateSettings(e);
                                }}
                                checked={customization.shoplogo}
                                name="shoplogo"
                              >
                                Shop Logo
                              </Checkbox>{" "}
                              <div className="checkbox-design">
                                Enable/disable your shop logo.
                              </div>
                            </div>
                          )}
                          <div>
                            <Checkbox
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              checked={customization.ShopAddress}
                              name="ShopAddress"
                            >
                              Shop Address
                            </Checkbox>{" "}
                            <div className="checkbox-design">
                              Enable/disable your shop Address.
                            </div>
                          </div>
                          {/* <li><Checkbox onClick={(e)=>updateSettings(e)} checked={customization.billingaddress}  name='billingaddress'>Billing Address</Checkbox><p>Add the name and address of the person to whome it is billed.</p></li> */}
                        </>
                      ) : null}
                    </div>
                    <div className="THERMAL-right-body">
                      <div
                        style={{ display: "flex" }}
                        onClick={() => setBshow(!bshow)}
                      >
                        <div style={{ fontSize: "20px", padding: "5px" }}>
                          Body
                        </div>
                        <div style={{ marginLeft: "auto" }}>
                          {bshow ? (
                            <i class="arrow down"></i>
                          ) : (
                            <i class="arrow up"></i>
                          )}
                        </div>
                      </div>
                      <hr />

                      {/* <div style={{ fontSize: "17px", padding: "5px" }}>
                  Bill Settings
                </div> */}
                      {bshow ? (
                        <div>
                          {Xerox.printerType === "A4" && (
                            <>
                              <div>
                                <Checkbox
                                  checked={customization.variant}
                                  onClick={(e) => updateSettings(e)}
                                  name="variant"
                                >
                                  Variant
                                </Checkbox>
                                <div className="checkbox-design">
                                  Add Variant of the product.
                                </div>
                              </div>
                            </>
                          )}
                          <div>
                            <Checkbox
                              checked={customization.itemmrp}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="itemmrp"
                            >
                              Item MRP
                            </Checkbox>
                            <div className="checkbox-design">
                              Add MRP of the product.
                            </div>
                          </div>

                          <div>
                            <Checkbox
                              checked={customization.itemdiscount}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="itemdiscount"
                            >
                              Item Discount
                            </Checkbox>
                            <div className="checkbox-design">
                              Discount will be added to the product level.
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              checked={customization.hsncode}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="hsncode"
                            >
                              HSN Code
                            </Checkbox>
                            <div className="checkbox-design">
                              Add HSN code of the product if available.
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              checked={customization.itemleveltax}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="itemleveltax"
                            >
                              Item Level Taxes
                            </Checkbox>
                            <div className="checkbox-design">
                              {" "}
                              Apply tax for separate items.
                            </div>
                          </div>
                          {shopDetails.shopType === "Mobile" && (
                            <div>
                              <Checkbox
                                checked={customization.imei1imei2}
                                onClick={(e) => {
                                  if (!access.otherAccess(false)) {
                                    return alert(
                                      "You don't have access, Please contact your administrator to request the appropriate access."
                                    );
                                  }
                                  updateSettings(e);
                                }}
                                name="imei1imei2"
                              >
                                IMEI1/IMEI2
                              </Checkbox>
                              <div className="checkbox-design">
                                Add IMEI number of the product
                              </div>
                            </div>
                          )}
                          <div>
                            <Checkbox
                              checked={customization.adddiscount}
                              onClick={(e) => {
                                if (!access.discount(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="adddiscount"
                            >
                              Add Discount
                            </Checkbox>
                            <div className="checkbox-design">
                              Discount will be applied on the sub total.
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              checked={customization.othercharges}
                              onClick={(e) => {
                                if (!access.otherCharges(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="othercharges"
                            >
                              Other charges
                            </Checkbox>
                            <div className="checkbox-design">
                              Create your own custom charges.
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              checked={customization.roundOff}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="roundOff"
                            >
                              Round Off
                            </Checkbox>
                            <div className="checkbox-design">
                              Adjusted to the nearest whole number for
                              simplified payment
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="THERMAL-right-footer">
                      <div
                        style={{ display: "flex" }}
                        onClick={() => setFshow(!Fshow)}
                      >
                        <div style={{ fontSize: "20px", padding: "5px" }}>
                          Footer{" "}
                        </div>
                        <div style={{ marginLeft: "auto" }}>
                          {Fshow ? (
                            <i class="arrow down"></i>
                          ) : (
                            <i class="arrow up"></i>
                          )}
                        </div>
                      </div>

                      <hr />
                      {Fshow ? (
                        <div>
                          <div>
                            <Checkbox
                              checked={customization.deliveryaddress}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="deliveryaddress"
                            >
                              {Xerox.A4design !== "Tabular" ? (
                                <> Delivery Address</>
                              ) : (
                                <>Customer Details</>
                              )}
                            </Checkbox>
                            <div className="checkbox-design">
                              Enable/Disable your delivery address.
                            </div>
                          </div>
                          {Xerox.printerType === "A4" && (
                            <div>
                              <Checkbox
                                checked={customization.ghoshaklogo}
                                onClick={(e) => {
                                  if (!access.otherAccess(false)) {
                                    return alert(
                                      "You don't have access, Please contact your administrator to request the appropriate access."
                                    );
                                  }
                                  updateSettings(e);
                                }}
                                name="ghoshaklogo"
                              >
                                Ghoshak Partner
                              </Checkbox>
                              <div className="checkbox-design">
                                Enable/Disable your Ghoshak Partner .
                              </div>
                            </div>
                          )}
                          {Xerox.printerType === "Thermal" && (
                            <div>
                              <Checkbox
                                checked={customization.QRCode}
                                onClick={(e) => {
                                  if (!access.otherAccess(false)) {
                                    return alert(
                                      "You don't have access, Please contact your administrator to request the appropriate access."
                                    );
                                  }
                                  updateSettings(e);
                                }}
                                name="QRCode"
                              >
                                QRCode
                              </Checkbox>
                              <div className="checkbox-design">
                                Enable/Disable your QRCode .
                              </div>
                            </div>
                          )}
                          <div>
                            <Checkbox
                              checked={customization.termscondition}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="termscondition"
                            >
                              Terms & Conditions
                            </Checkbox>{" "}
                            <div className="checkbox-design">
                              Add the terms and conditions which is to be
                              displayed.
                            </div>
                            <div style={{ marginLeft: "30px" }}>
                              {customization.termscondition && (
                                <textarea
                                  onChange={(e) => {
                                    if (!access.otherAccess(false)) {
                                      return alert(
                                        "You don't have access, Please contact your administrator to request the appropriate access."
                                      );
                                    }
                                    updateText(e);
                                  }}
                                  maxlength="250"
                                  row="3"
                                  value={Invoicetext.tAndCField}
                                  name="tAndCField"
                                  placeholder="Enter the Terms&conditions"
                                  style={{
                                    width: "300px",
                                    height: "102px",
                                    overFlow: "hidden",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          {Xerox.A4design !== "Tabular" && (
                            <div>
                              <Checkbox
                                checked={customization.paymenyterms}
                                onClick={(e) => {
                                  if (!access.otherAccess(false)) {
                                    return alert(
                                      "You don't have access, Please contact your administrator to request the appropriate access."
                                    );
                                  }
                                  updateSettings(e);
                                }}
                                name="paymenyterms"
                              >
                                Payment Terms
                              </Checkbox>
                              <div className="checkbox-design">
                                Add the payment terms that will be displayed in
                                the invoice.
                              </div>
                              <div style={{ marginLeft: "30px" }}>
                                {customization.paymenyterms && (
                                  <textarea
                                    row="3"
                                    maxlength="250"
                                    onChange={(e) => {
                                      if (!access.otherAccess(false)) {
                                        return alert(
                                          "You don't have access, Please contact your administrator to request the appropriate access."
                                        );
                                      }
                                      updateText(e);
                                    }}
                                    placeholder="Enter Payment Terms"
                                    name="paymentTermsField"
                                    value={Invoicetext.paymentTermsField}
                                    style={{
                                      width: "300px",
                                      height: "102px",
                                      overFlow: "hidden",
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          )}

                          <>
                            <Checkbox
                              checked={customization.notes}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="notes"
                            >
                              <div>
                                {Xerox.A4design !== "Tabular" ? (
                                  <>Notes</>
                                ) : (
                                  <>Notes/Declaration</>
                                )}
                              </div>
                            </Checkbox>
                            <div className="checkbox-design">
                              <div>
                                {Xerox.A4design !== "Tabular" ? (
                                  <>
                                    {" "}
                                    Add the Notes that will be displayed in the
                                    invoice.
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    Add the Declaration that will be displayed
                                    in the invoice.
                                  </>
                                )}
                              </div>
                            </div>
                          </>

                          {/* <li><Checkbox checked={customization.duedate} onClick={(e)=>updateSettings(e)}  name="duedate">Due date</Checkbox><p >Add the due date from bill payment.</p></li> */}
                          <div>
                            <Checkbox
                              checked={customization.invoiceprefix}
                              onClick={(e) => {
                                if (!access.otherAccess(false)) {
                                  return alert(
                                    "You don't have access, Please contact your administrator to request the appropriate access."
                                  );
                                }
                                updateSettings(e);
                              }}
                              name="invoiceprefix"
                            >
                              Invoice Prefix
                            </Checkbox>
                            <div className="checkbox-design">
                              Add prefix for the invoice.
                            </div>
                            {customization.invoiceprefix && (
                              <div style={{ marginLeft: "30px" }}>
                                <input
                                  onChange={(e) => {
                                    if (!access.otherAccess(false)) {
                                      return alert(
                                        "You don't have access, Please contact your administrator to request the appropriate access."
                                      );
                                    }
                                    updateText(e);
                                  }}
                                  value={Invoicetext.invoicePrefixtext}
                                  name="invoicePrefixtext"
                                  placeholder="Enter invoice prefix(eg GHK)"
                                  style={{
                                    width: "300px",
                                    marginBottom: "5px",
                                  }}
                                />

                                {/* <input
                            onChange={(e) => updateText(e)}
                            value={Invoicetext.invoiceSuffixtext}
                            name="invoiceSuffixtext"
                          
                            placeholder="Enter invoice suffix(eg 0001)"
                            style={{ width: "300px", marginLeft: "2px" }}
                          /> */}
                                <input
                                  type="number"
                                  style={{ width: "300px" }}
                                  placeholder="Enter invoice suffix(eg 0001)"
                                  value={Invoicetext.currentInvoiceNumber}
                                  onChange={(e) => {
                                    if (!access.otherAccess(false)) {
                                      return alert(
                                        "You don't have access, Please contact your administrator to request the appropriate access."
                                      );
                                    }
                                    setInvoicetext((prev) => ({
                                      ...prev,
                                      invoiceSuffixtext: e.target.value,
                                      currentInvoiceNumber: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </form>
                  <></>
                  <div style={{ height: "10px" }}></div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default Invoice;
